import classNames from "classnames";

export function UploadIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7988 1.01877C12.6771 1.44183 14.209 2.39737 15.3946 3.88537C16.5801 5.37337 17.1732 7.07926 17.1738 9.00306C17.1738 10.9256 16.578 12.6303 15.3864 14.1171C14.1942 15.6039 12.665 16.5585 10.7988 16.981C10.6509 17.0222 10.5224 16.9964 10.4133 16.9037C10.3042 16.811 10.2496 16.6873 10.2496 16.5328C10.2496 16.4249 10.2793 16.3309 10.3387 16.2509C10.3975 16.1721 10.4787 16.1218 10.5824 16.1C12.2492 15.7212 13.6129 14.8726 14.6736 13.5543C15.7343 12.236 16.2647 10.7208 16.2647 9.00851C16.2647 7.29625 15.7343 5.78097 14.6736 4.46269C13.6129 3.1444 12.2492 2.29584 10.5824 1.91702C10.4751 1.88308 10.393 1.8252 10.336 1.74337C10.279 1.66155 10.2505 1.56851 10.2505 1.46426C10.2505 1.31516 10.3051 1.19333 10.4142 1.09877C10.5233 1.00422 10.6515 0.977552 10.7988 1.01877ZM7.18393 1.03604C7.3203 0.994826 7.44576 1.01937 7.56032 1.10968C7.67548 1.2006 7.73306 1.32091 7.73306 1.47062C7.73306 1.57609 7.7073 1.66821 7.65578 1.74701C7.60426 1.82641 7.52486 1.88308 7.41758 1.91702C7.00543 2.00794 6.60479 2.1331 6.21566 2.29251C5.82593 2.45131 5.4556 2.64435 5.10467 2.87165C5.01981 2.92317 4.92738 2.94135 4.82737 2.9262C4.72797 2.91044 4.64129 2.86437 4.56735 2.788C4.46431 2.68072 4.42188 2.5595 4.44006 2.42434C4.45885 2.29039 4.52553 2.18068 4.64008 2.09522C5.03345 1.85096 5.44378 1.64033 5.87109 1.46335C6.2984 1.28697 6.73601 1.14454 7.18393 1.03604ZM2.78175 4.57269C2.85569 4.65088 2.89903 4.73695 2.91176 4.8309C2.92509 4.92484 2.906 5.01424 2.85448 5.0991C2.62719 5.44458 2.43384 5.8131 2.27443 6.20464C2.11563 6.59559 1.99078 6.9941 1.89986 7.4002C1.87743 7.50505 1.82531 7.58567 1.74348 7.64203C1.66166 7.6984 1.56862 7.72659 1.46437 7.72659C1.31527 7.72659 1.19344 7.67204 1.09888 7.56294C1.00433 7.45384 0.977662 7.32564 1.01888 7.17836C1.12737 6.72984 1.26981 6.29223 1.44618 5.86553C1.62317 5.43822 1.83379 5.02758 2.07805 4.63361C2.16291 4.51966 2.27565 4.45329 2.41626 4.4345C2.55688 4.41632 2.67871 4.46299 2.78175 4.57269ZM1.46164 10.2677C1.57316 10.2677 1.66863 10.2932 1.74803 10.3441C1.82682 10.3956 1.87743 10.475 1.89986 10.5823C1.9932 10.9914 2.12169 11.389 2.28534 11.7751C2.44899 12.1612 2.63871 12.5346 2.85448 12.8952C2.91752 12.9837 2.93964 13.0776 2.92085 13.177C2.90267 13.277 2.8563 13.364 2.78175 13.438C2.67871 13.541 2.55658 13.5852 2.41535 13.5707C2.27474 13.5562 2.1626 13.4861 2.07896 13.3607C1.83409 12.9667 1.62317 12.5561 1.44618 12.1288C1.27041 11.7015 1.12798 11.2638 1.01888 10.8159C0.977662 10.6796 1.0016 10.5541 1.0907 10.4395C1.17919 10.3244 1.30284 10.2668 1.46164 10.2668M5.10466 15.1454C5.45318 15.3727 5.82048 15.566 6.20657 15.7254C6.59266 15.8848 6.99057 16.0097 7.4003 16.1C7.50334 16.1224 7.58456 16.1745 7.64396 16.2564C7.70275 16.3382 7.73215 16.4312 7.73215 16.5355C7.73215 16.6846 7.6776 16.8064 7.5685 16.901C7.4594 16.9955 7.33121 17.0222 7.18392 16.981C6.72995 16.8719 6.29052 16.7334 5.86563 16.5655C5.44136 16.3976 5.03254 16.183 4.63917 15.9218C4.52158 15.8369 4.4534 15.7269 4.43461 15.5918C4.41643 15.4572 4.45885 15.3351 4.56189 15.2254C4.63584 15.1466 4.72251 15.0978 4.82191 15.079C4.92192 15.0608 5.01617 15.0829 5.10466 15.1454ZM8.54131 6.84924L6.05565 9.33581C5.95564 9.43582 5.84654 9.48582 5.72835 9.48582C5.61077 9.48582 5.50167 9.43582 5.40105 9.33581C5.30165 9.23519 5.25255 9.12609 5.25377 9.00851C5.25559 8.89092 5.3068 8.78182 5.40742 8.68121L8.48221 5.60641C8.62586 5.46277 8.79739 5.39094 8.9968 5.39094C9.19621 5.39094 9.36744 5.46277 9.51048 5.60641L12.5962 8.69758C12.6968 8.79758 12.7462 8.90547 12.7444 9.02124C12.7426 9.13761 12.6916 9.2458 12.5916 9.34581C12.491 9.44642 12.3828 9.49673 12.2671 9.49673C12.1513 9.49673 12.0431 9.44642 11.9425 9.34581L9.45138 6.84924L9.45138 12.4706C9.45138 12.5991 9.40774 12.707 9.32046 12.7943C9.23318 12.8816 9.12499 12.9252 8.99589 12.9252C8.86679 12.9252 8.7589 12.8816 8.67223 12.7943C8.58555 12.707 8.54222 12.5991 8.54222 12.4706L8.54131 6.84924Z"
        fill="#8D8D8D"
      />
      <path
        d="M1.46164 10.2677C1.57316 10.2677 1.66863 10.2932 1.74803 10.3441C1.82682 10.3956 1.87743 10.475 1.89986 10.5823C1.9932 10.9914 2.12169 11.389 2.28534 11.7751C2.44899 12.1612 2.63871 12.5346 2.85448 12.8952C2.91752 12.9837 2.93964 13.0776 2.92085 13.177C2.90267 13.277 2.8563 13.364 2.78175 13.438C2.67871 13.541 2.55658 13.5852 2.41535 13.5707C2.27474 13.5562 2.16261 13.4861 2.07896 13.3607C1.83409 12.9667 1.62317 12.5561 1.44618 12.1288C1.27041 11.7015 1.12798 11.2638 1.01888 10.8159C0.977662 10.6796 1.0016 10.5541 1.0907 10.4395C1.17919 10.3244 1.30284 10.2668 1.46164 10.2668M10.7988 1.01877C12.6771 1.44183 14.209 2.39737 15.3946 3.88537C16.5801 5.37337 17.1732 7.07926 17.1738 9.00306C17.1738 10.9256 16.578 12.6303 15.3864 14.1171C14.1942 15.6039 12.665 16.5585 10.7988 16.981C10.6509 17.0222 10.5224 16.9964 10.4133 16.9037C10.3042 16.811 10.2496 16.6873 10.2496 16.5328C10.2496 16.4249 10.2793 16.3309 10.3387 16.2509C10.3975 16.1721 10.4787 16.1218 10.5824 16.1C12.2492 15.7212 13.6129 14.8726 14.6736 13.5543C15.7343 12.236 16.2647 10.7208 16.2647 9.00851C16.2647 7.29625 15.7343 5.78097 14.6736 4.46269C13.6129 3.1444 12.2492 2.29584 10.5824 1.91702C10.4751 1.88308 10.393 1.8252 10.336 1.74337C10.279 1.66155 10.2505 1.56851 10.2505 1.46426C10.2505 1.31516 10.3051 1.19333 10.4142 1.09877C10.5233 1.00422 10.6515 0.977552 10.7988 1.01877ZM7.18392 1.03604C7.3203 0.994827 7.44576 1.01937 7.56032 1.10968C7.67548 1.2006 7.73306 1.32091 7.73306 1.47062C7.73306 1.57609 7.7073 1.66821 7.65578 1.74701C7.60426 1.82641 7.52486 1.88308 7.41758 1.91702C7.00543 2.00794 6.60479 2.1331 6.21566 2.29251C5.82593 2.45131 5.4556 2.64435 5.10466 2.87165C5.01981 2.92316 4.92738 2.94135 4.82737 2.9262C4.72797 2.91044 4.64129 2.86437 4.56735 2.788C4.46431 2.68072 4.42188 2.5595 4.44006 2.42434C4.45885 2.29039 4.52553 2.18068 4.64008 2.09522C5.03345 1.85096 5.44378 1.64033 5.87109 1.46335C6.2984 1.28697 6.73601 1.14454 7.18392 1.03604ZM2.78175 4.57269C2.85569 4.65088 2.89903 4.73695 2.91176 4.8309C2.92509 4.92484 2.906 5.01424 2.85448 5.0991C2.62719 5.44458 2.43384 5.8131 2.27443 6.20464C2.11563 6.59559 1.99077 6.9941 1.89986 7.4002C1.87743 7.50505 1.82531 7.58567 1.74348 7.64203C1.66166 7.6984 1.56862 7.72659 1.46437 7.72659C1.31527 7.72659 1.19344 7.67204 1.09888 7.56294C1.00433 7.45384 0.977662 7.32564 1.01888 7.17836C1.12737 6.72984 1.26981 6.29223 1.44618 5.86553C1.62317 5.43822 1.83379 5.02758 2.07805 4.63361C2.16291 4.51966 2.27565 4.45329 2.41626 4.4345C2.55688 4.41632 2.67871 4.46299 2.78175 4.57269ZM5.10466 15.1454C5.45318 15.3727 5.82048 15.566 6.20657 15.7254C6.59266 15.8848 6.99057 16.0097 7.4003 16.1C7.50334 16.1224 7.58456 16.1745 7.64396 16.2564C7.70275 16.3382 7.73215 16.4312 7.73215 16.5355C7.73215 16.6846 7.6776 16.8064 7.5685 16.901C7.4594 16.9955 7.33121 17.0222 7.18392 16.981C6.72995 16.8719 6.29052 16.7334 5.86563 16.5655C5.44136 16.3976 5.03254 16.183 4.63917 15.9218C4.52158 15.8369 4.4534 15.7269 4.43461 15.5918C4.41643 15.4572 4.45885 15.3351 4.56189 15.2254C4.63584 15.1466 4.72251 15.0978 4.82191 15.079C4.92192 15.0608 5.01617 15.0829 5.10466 15.1454ZM8.54131 6.84924L6.05565 9.33581C5.95564 9.43582 5.84654 9.48582 5.72835 9.48582C5.61077 9.48582 5.50167 9.43582 5.40105 9.33581C5.30165 9.23519 5.25255 9.12609 5.25377 9.00851C5.25559 8.89092 5.3068 8.78182 5.40742 8.68121L8.48221 5.60641C8.62586 5.46277 8.79739 5.39094 8.9968 5.39094C9.19621 5.39094 9.36744 5.46277 9.51048 5.60641L12.5962 8.69758C12.6968 8.79758 12.7462 8.90547 12.7444 9.02124C12.7426 9.13761 12.6916 9.2458 12.5916 9.34581C12.491 9.44642 12.3828 9.49673 12.2671 9.49673C12.1513 9.49673 12.0431 9.44642 11.9425 9.34581L9.45138 6.84924L9.45138 12.4706C9.45138 12.5991 9.40774 12.707 9.32046 12.7943C9.23318 12.8816 9.12499 12.9252 8.99589 12.9252C8.86679 12.9252 8.7589 12.8816 8.67223 12.7943C8.58555 12.707 8.54222 12.5991 8.54222 12.4706L8.54131 6.84924Z"
        stroke="#8D8D8D"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function LeftCircleIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16.6133C9.58225 16.6133 11.129 16.1394 12.4446 15.2514C13.7602 14.3635 14.7855 13.1015 15.391 11.625C15.9965 10.1484 16.155 8.52367 15.8463 6.95618C15.5376 5.38869 14.7757 3.94886 13.6569 2.81876C12.538 1.68866 11.1126 0.919055 9.56072 0.607261C8.00887 0.295467 6.40034 0.455491 4.93853 1.0671C3.47672 1.6787 2.2273 2.71442 1.34824 4.04327C0.469193 5.37213 1.79138e-06 6.93444 1.65306e-06 8.53264C0.00224069 10.6751 0.845815 12.7291 2.34562 14.244C3.84542 15.7589 5.87895 16.611 8 16.6133ZM8 1.69517C9.33883 1.69517 10.6476 2.09618 11.7608 2.84749C12.874 3.5988 13.7416 4.66667 14.254 5.91605C14.7663 7.16543 14.9004 8.54022 14.6392 9.86656C14.378 11.1929 13.7333 12.4112 12.7866 13.3675C11.8399 14.3237 10.6337 14.9749 9.32061 15.2387C8.00751 15.5025 6.64644 15.3671 5.40953 14.8496C4.17261 14.3321 3.1154 13.4557 2.37159 12.3313C1.62778 11.2069 1.23077 9.88496 1.23077 8.53264C1.23281 6.71986 1.94664 4.98192 3.21568 3.70009C4.48472 2.41826 6.20531 1.69722 8 1.69517ZM5.71846 8.97241C5.66125 8.91468 5.61585 8.84613 5.58489 8.77067C5.55392 8.69521 5.53798 8.61432 5.53798 8.53264C5.53798 8.45095 5.55392 8.37006 5.58489 8.29461C5.61585 8.21915 5.66125 8.15059 5.71846 8.09286L8.79538 4.98492C8.85256 4.92717 8.92044 4.88136 8.99514 4.85011C9.06984 4.81885 9.14991 4.80276 9.23077 4.80276C9.31163 4.80276 9.39169 4.81885 9.4664 4.85011C9.5411 4.88136 9.60898 4.92717 9.66615 4.98492C9.72333 5.04267 9.76868 5.11124 9.79963 5.18669C9.83057 5.26215 9.8465 5.34302 9.8465 5.4247C9.8465 5.50637 9.83057 5.58724 9.79963 5.6627C9.76868 5.73816 9.72333 5.80672 9.66615 5.86447L7.02385 8.53264L9.66615 11.2008C9.78162 11.3174 9.84649 11.4756 9.84649 11.6406C9.84649 11.8055 9.78162 11.9637 9.66615 12.0804C9.55068 12.197 9.39407 12.2625 9.23077 12.2625C9.06747 12.2625 8.91085 12.197 8.79538 12.0804L5.71846 8.97241Z"
        fill="#8D8D8D"
      />
    </svg>
  );
}

export function RightCircleIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.451172C6.41775 0.451172 4.87103 0.925093 3.55544 1.81301C2.23985 2.70092 1.21447 3.96294 0.608967 5.43949C0.00346628 6.91603 -0.15496 8.54078 0.153721 10.1083C0.462403 11.6758 1.22433 13.1156 2.34315 14.2457C3.46197 15.3758 4.88743 16.1454 6.43928 16.4572C7.99113 16.769 9.59966 16.609 11.0615 15.9974C12.5233 15.3858 13.7727 14.35 14.6518 13.0212C15.5308 11.6923 16 10.13 16 8.53182C15.9978 6.38939 15.1542 4.33536 13.6544 2.82044C12.1546 1.30551 10.121 0.453434 8 0.451172ZM8 15.3693C6.66117 15.3693 5.35241 14.9683 4.23922 14.217C3.12603 13.4657 2.2584 12.3978 1.74605 11.1484C1.2337 9.89902 1.09965 8.52423 1.36084 7.19789C1.62203 5.87155 2.26674 4.65323 3.21343 3.697C4.16013 2.74076 5.36629 2.08955 6.67939 1.82573C7.99249 1.5619 9.35356 1.69731 10.5905 2.21482C11.8274 2.73233 12.8846 3.60871 13.6284 4.73312C14.3722 5.85754 14.7692 7.17949 14.7692 8.53182C14.7672 10.3446 14.0534 12.0825 12.7843 13.3644C11.5153 14.6462 9.79469 15.3672 8 15.3693ZM10.2815 8.09204C10.3388 8.14977 10.3841 8.21833 10.4151 8.29378C10.4461 8.36924 10.462 8.45013 10.462 8.53182C10.462 8.6135 10.4461 8.69439 10.4151 8.76985C10.3841 8.84531 10.3388 8.91386 10.2815 8.97159L7.20462 12.0795C7.14744 12.1373 7.07956 12.1831 7.00486 12.2143C6.93016 12.2456 6.85009 12.2617 6.76923 12.2617C6.68837 12.2617 6.60831 12.2456 6.5336 12.2143C6.4589 12.1831 6.39102 12.1373 6.33385 12.0795C6.27667 12.0218 6.23132 11.9532 6.20038 11.8778C6.16943 11.8023 6.15351 11.7214 6.15351 11.6398C6.15351 11.5581 6.16943 11.4772 6.20038 11.4018C6.23132 11.3263 6.27667 11.2577 6.33385 11.2L8.97616 8.53182L6.33385 5.86365C6.21838 5.74701 6.15351 5.58882 6.15351 5.42388C6.15351 5.25893 6.21838 5.10074 6.33385 4.9841C6.44932 4.86747 6.60593 4.80194 6.76923 4.80194C6.93253 4.80194 7.08915 4.86747 7.20462 4.9841L10.2815 8.09204Z"
        fill="#8D8D8D"
      />
    </svg>
  );
}

export function DustbinIcon({ fill = "#8D8D8D" }) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8177 2.40308H10.8138V1.80231C10.8138 1.32431 10.624 0.865882 10.286 0.527884C9.94796 0.189886 9.48954 0 9.01154 0H5.40692C4.92892 0 4.4705 0.189886 4.1325 0.527884C3.7945 0.865882 3.60462 1.32431 3.60462 1.80231V2.40308H0.600769C0.441435 2.40308 0.288627 2.46637 0.175961 2.57904C0.0632953 2.6917 0 2.84451 0 3.00385C0 3.16318 0.0632953 3.31599 0.175961 3.42865C0.288627 3.54132 0.441435 3.60462 0.600769 3.60462H1.20154V14.4185C1.20154 14.7371 1.32813 15.0427 1.55346 15.2681C1.77879 15.4934 2.08441 15.62 2.40308 15.62H12.0154C12.3341 15.62 12.6397 15.4934 12.865 15.2681C13.0903 15.0427 13.2169 14.7371 13.2169 14.4185V3.60462H13.8177C13.977 3.60462 14.1298 3.54132 14.2425 3.42865C14.3552 3.31599 14.4185 3.16318 14.4185 3.00385C14.4185 2.84451 14.3552 2.6917 14.2425 2.57904C14.1298 2.46637 13.977 2.40308 13.8177 2.40308ZM4.80615 1.80231C4.80615 1.64297 4.86945 1.49017 4.98212 1.3775C5.09478 1.26483 5.24759 1.20154 5.40692 1.20154H9.01154C9.17087 1.20154 9.32368 1.26483 9.43635 1.3775C9.54901 1.49017 9.61231 1.64297 9.61231 1.80231V2.40308H4.80615V1.80231ZM12.0154 14.4185H2.40308V3.60462H12.0154V14.4185ZM6.00769 6.60846V11.4146C6.00769 11.5739 5.9444 11.7268 5.83173 11.8394C5.71907 11.9521 5.56626 12.0154 5.40692 12.0154C5.24759 12.0154 5.09478 11.9521 4.98212 11.8394C4.86945 11.7268 4.80615 11.5739 4.80615 11.4146V6.60846C4.80615 6.44913 4.86945 6.29632 4.98212 6.18365C5.09478 6.07099 5.24759 6.00769 5.40692 6.00769C5.56626 6.00769 5.71907 6.07099 5.83173 6.18365C5.9444 6.29632 6.00769 6.44913 6.00769 6.60846ZM9.61231 6.60846V11.4146C9.61231 11.5739 9.54901 11.7268 9.43635 11.8394C9.32368 11.9521 9.17087 12.0154 9.01154 12.0154C8.85221 12.0154 8.6994 11.9521 8.58673 11.8394C8.47406 11.7268 8.41077 11.5739 8.41077 11.4146V6.60846C8.41077 6.44913 8.47406 6.29632 8.58673 6.18365C8.6994 6.07099 8.85221 6.00769 9.01154 6.00769C9.17087 6.00769 9.32368 6.07099 9.43635 6.18365C9.54901 6.29632 9.61231 6.44913 9.61231 6.60846Z"
        fill={fill}
      />
    </svg>
  );
}

export function PencilIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2586 3.85762L11.768 0.366217C11.6519 0.250114 11.5141 0.158014 11.3624 0.0951779C11.2107 0.0323417 11.0482 0 10.884 0C10.7198 0 10.5572 0.0323417 10.4056 0.0951779C10.2539 0.158014 10.1161 0.250114 10 0.366217L0.366412 10.0006C0.249834 10.1162 0.157407 10.2539 0.0945056 10.4056C0.0316038 10.5573 -0.000518312 10.72 6.32418e-06 10.8842V14.3756C6.32418e-06 14.7071 0.131702 15.0251 0.366123 15.2595C0.600543 15.4939 0.918486 15.6256 1.25001 15.6256H4.74141C4.90563 15.6261 5.0683 15.594 5.21999 15.5311C5.37168 15.4682 5.50935 15.3758 5.62501 15.2592L15.2586 5.62559C15.3747 5.50952 15.4668 5.3717 15.5296 5.22003C15.5925 5.06835 15.6248 4.90578 15.6248 4.74161C15.6248 4.57743 15.5925 4.41486 15.5296 4.26319C15.4668 4.11151 15.3747 3.9737 15.2586 3.85762ZM4.74141 14.3756H1.25001V10.8842L8.12501 4.00919L11.6164 7.50059L4.74141 14.3756ZM12.5 6.61622L9.0086 3.12559L10.8836 1.25059L14.375 4.74122L12.5 6.61622Z"
        fill="#8D8D8D"
      />
    </svg>
  );
}

export function InfoIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_939_17246)">
        <path
          d="M7 4.75C7 4.338 7.338 4 7.75 4H8.25C8.662 4 9 4.338 9 4.75V5.25C9 5.662 8.662 6 8.25 6H7.75C7.55133 5.99921 7.36102 5.91994 7.22054 5.77946C7.08006 5.63898 7.00079 5.44867 7 5.25V4.75ZM10 12H6V11H7V8H6V7H9V11H10V12Z"
          fill="#7E67BF"
        />
        <path
          d="M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 14.5C6.27609 14.5 4.62279 13.8152 3.40381 12.5962C2.18482 11.3772 1.5 9.72391 1.5 8C1.5 6.27609 2.18482 4.62279 3.40381 3.40381C4.62279 2.18482 6.27609 1.5 8 1.5C9.72391 1.5 11.3772 2.18482 12.5962 3.40381C13.8152 4.62279 14.5 6.27609 14.5 8C14.5 9.72391 13.8152 11.3772 12.5962 12.5962C11.3772 13.8152 9.72391 14.5 8 14.5Z"
          fill="#7E67BF"
        />
      </g>
      <defs>
        <clipPath id="clip0_939_17246">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LatinTIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#F0C375" fillOpacity="0.18" />
      <path
        d="M23.7295 10.9336L23.8906 14.3496H23.4824C23.4036 13.748 23.2962 13.3184 23.1602 13.0605C22.9382 12.6452 22.641 12.3408 22.2686 12.1475C21.9033 11.9469 21.4199 11.8467 20.8184 11.8467H18.7666V22.9756C18.7666 23.8708 18.8633 24.4294 19.0566 24.6514C19.3288 24.9521 19.7477 25.1025 20.3135 25.1025H20.8184V25.5H14.6416V25.1025H15.1572C15.7731 25.1025 16.21 24.9163 16.4678 24.5439C16.6253 24.3148 16.7041 23.792 16.7041 22.9756V11.8467H14.9531C14.2728 11.8467 13.7894 11.8968 13.5029 11.9971C13.1305 12.1331 12.8118 12.3945 12.5469 12.7812C12.2819 13.168 12.1243 13.6908 12.0742 14.3496H11.666L11.8379 10.9336H23.7295Z"
        fill="#060606"
        fillOpacity="0.8"
      />
    </svg>
  );
}

export function CompletedIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="8" fill="#49AB2E" />
      <path
        d="M5.33594 7.99995L7.11372 9.77772L10.6693 6.22217"
        stroke="white"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LogoIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#B946E0" fillOpacity="0.08" />
      <path
        d="M16.5441 9.76201C14.4426 9.76201 12.5114 10.3166 10.8378 11.2806C12.6231 9.40337 15.1574 8.21331 18.0005 8.21331C23.3679 8.21331 27.7863 12.6317 27.7863 17.9991C27.7863 18.4832 27.7487 18.9598 27.678 19.4246C27.3356 16.9337 26.1865 14.7372 24.4527 13.0033C22.4482 10.9988 19.5906 9.76201 16.5441 9.76201Z"
        stroke="#B946E0"
      />
      <path
        d="M23.5993 19.4552C23.5993 17.1936 22.9175 15.034 21.7064 13.2503C22.2183 13.5869 22.6826 13.973 23.0948 14.4226L23.1021 14.4306L23.1098 14.4383C24.7469 16.0755 25.7851 18.4065 25.7851 21.0027C25.7851 22.3736 25.5325 23.7246 24.9606 24.8996C23.6936 26.2118 22.0242 27.1681 20.1455 27.5743C20.1847 27.5365 20.2238 27.4981 20.2629 27.459C22.3647 25.4505 23.5993 22.5894 23.5993 19.4552Z"
        stroke="#B946E0"
      />
      <path
        d="M8.53373 20.5075C9.02913 21.3762 9.63952 22.1781 10.3651 22.9037C12.3696 24.9082 15.2272 26.1449 18.2737 26.1449L18.2963 26.1449C18.4959 26.145 18.6937 26.145 18.8934 26.1384C18.258 26.7652 17.4698 27.2543 16.619 27.7659C12.686 27.2042 9.51889 24.2997 8.53373 20.5075Z"
        stroke="#B946E0"
      />
      <g filter="url(#filter0_f_939_23518)">
        <circle
          cx="18.25"
          cy="18.25"
          r="8.25"
          fill="#F8F2E2"
          fillOpacity="0.15"
        />
        <circle
          cx="18.25"
          cy="18.25"
          r="7.975"
          stroke="white"
          strokeWidth="0.55"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_939_23518"
          x="1.4"
          y="1.4"
          width="33.7"
          height="33.7"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.3"
            result="effect1_foregroundBlur_939_23518"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function PackageIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#F5F7EC" />
      <path
        d="M28.2837 11.331C28.2818 11.2445 28.2548 11.1604 28.2058 11.089C28.1569 11.0176 28.0882 10.962 28.0082 10.9291L18.1708 6.89049C18.0631 6.8464 17.9424 6.8464 17.8347 6.89049L7.9956 10.9273C7.90203 10.9637 7.8237 11.0309 7.77359 11.1179C7.72349 11.2048 7.70462 11.3063 7.72012 11.4055C7.7194 11.4199 7.7194 11.4344 7.72012 11.4488V24.2419C7.71995 24.3276 7.74456 24.4114 7.79098 24.4833C7.8374 24.5553 7.90365 24.6122 7.98174 24.6474L17.6753 28.9995L17.7134 29.0116L17.7446 29.022C17.8176 29.0434 17.8952 29.0434 17.9681 29.022L17.9976 29.0134L18.034 29.0012L28.0186 24.6491C28.098 24.6146 28.1655 24.5577 28.2129 24.4854C28.2603 24.413 28.2855 24.3284 28.2854 24.2419V11.4488C28.2862 11.4344 28.2862 11.4199 28.2854 11.4055C28.287 11.3807 28.2864 11.3557 28.2837 11.331ZM15.1164 9.04058L23.6058 12.769L21.6533 13.6578L13.1638 9.87914L15.1164 9.04058ZM24.2989 13.4724V19.0634L22.0985 20.0163L22.1003 14.4357L24.2989 13.4724ZM18.0028 7.78102L26.7227 11.3622L24.6991 12.277L16.1732 8.53121L18.0028 7.78102ZM11.8938 10.2863L20.5548 14.1343L17.9421 15.2829L9.27942 11.3622L11.8938 10.2863ZM8.60199 12.1332L17.4137 16.0886V27.9097L8.60719 23.9561L8.60199 12.1332ZM27.3966 23.9526L18.3008 27.9184V16.1544L21.2132 14.8273L21.234 20.6902C21.2342 20.7637 21.2527 20.8359 21.2877 20.9005C21.3228 20.9651 21.3734 21.0199 21.4348 21.0601C21.4963 21.1003 21.5668 21.1246 21.6401 21.1308C21.7133 21.137 21.7868 21.1249 21.8542 21.0956L24.9399 19.7598C25.0195 19.7256 25.0874 19.6689 25.1352 19.5965C25.1829 19.5241 25.2084 19.4394 25.2084 19.3527V13.0843L27.407 12.1262L27.3966 23.9526Z"
        fill="#89A318"
      />
    </svg>
  );
}

export function ProcessingIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.57538 11.7887C6.69419 11.8455 6.8328 11.9023 6.95162 11.9402C6.99122 11.9591 7.01102 11.978 7.03082 12.0348L7.14964 13.1332C7.16944 13.3036 7.32785 13.4362 7.50607 13.4362H8.49617C8.67439 13.4362 8.8328 13.3036 8.85261 13.1332L8.97142 12.0348C8.97142 11.997 9.01102 11.9591 9.05063 11.9402C9.18924 11.9023 9.30805 11.8455 9.42686 11.7887C9.46647 11.7697 9.50607 11.7697 9.54568 11.8076L10.4566 12.5083C10.5952 12.6219 10.813 12.603 10.9516 12.4893L11.6645 11.8076C11.8031 11.675 11.8031 11.4857 11.6843 11.3342L10.9516 10.4631C10.9318 10.4252 10.912 10.3873 10.9318 10.3494C10.9912 10.2358 11.0506 10.1033 11.0902 9.98964C11.11 9.95176 11.1298 9.93283 11.1892 9.91389L12.3378 9.80027C12.516 9.78133 12.6546 9.62983 12.6546 9.4594V8.51254C12.6546 8.34211 12.516 8.19061 12.3378 8.17168L11.1694 8.07699C11.1298 8.07699 11.0902 8.03912 11.0704 8.00124C11.0308 7.86868 10.9714 7.75506 10.912 7.64144C10.8922 7.60356 10.8922 7.56569 10.9318 7.52781L11.6645 6.65671C11.7833 6.52415 11.7635 6.31584 11.6447 6.18328L10.9318 5.50154C10.7932 5.36898 10.5952 5.36898 10.4368 5.48261L9.52587 6.18328C9.48627 6.20222 9.44667 6.22115 9.40706 6.20222C9.28825 6.14541 9.14964 6.08859 9.03082 6.05072C8.99122 6.03178 8.97142 6.01285 8.95162 5.95603L8.83281 4.85768C8.813 4.68725 8.65459 4.55469 8.47637 4.55469H7.48627C7.30805 4.55469 7.14964 4.68725 7.12983 4.85768L7.03082 5.97497C7.03082 6.01285 6.99122 6.05072 6.95162 6.06966C6.813 6.10753 6.69419 6.16434 6.57538 6.22115C6.53577 6.24009 6.49617 6.24009 6.45657 6.20222L5.54568 5.50154C5.40706 5.38792 5.18924 5.40686 5.05063 5.52048L4.33776 6.20222C4.19914 6.33478 4.19914 6.52415 4.31795 6.67564L5.05063 7.54675C5.07043 7.58463 5.09023 7.6225 5.07043 7.66037C5.01102 7.774 4.95162 7.90656 4.91201 8.02018C4.89221 8.05805 4.87241 8.07699 4.813 8.09593L3.66449 8.20955C3.48627 8.22849 3.34766 8.37998 3.34766 8.55042V9.49727C3.34766 9.66771 3.48627 9.8192 3.66449 9.83814L4.813 9.95176C4.85261 9.95176 4.89221 9.98964 4.91201 10.0275C4.95162 10.1601 5.01102 10.2737 5.07043 10.3873C5.09023 10.4252 5.09023 10.4631 5.05063 10.5009L4.31795 11.372C4.19914 11.5046 4.21894 11.7129 4.33776 11.8455L5.05063 12.5272C5.18924 12.6598 5.38726 12.6598 5.54568 12.5461L6.45657 11.8455C6.49617 11.7887 6.53577 11.7697 6.57538 11.7887ZM8.00112 7.35738C8.95162 7.35738 9.72389 8.09593 9.72389 9.00491C9.72389 9.91389 8.95162 10.6524 8.00112 10.6524C7.05063 10.6524 6.27835 9.91389 6.27835 9.00491C6.27835 8.09593 7.05063 7.35738 8.00112 7.35738Z"
        fill="#7A3DAA"
      />
      <path
        d="M0.970297 9.0046C0.970297 5.29292 4.11881 2.28192 8 2.28192H8.13861L7.56436 2.8311C7.36634 3.02047 7.36634 3.30453 7.56436 3.4939C7.66337 3.58858 7.78218 3.62646 7.90099 3.62646C8.0198 3.62646 8.15841 3.58858 8.23762 3.4939L9.64356 2.14936C9.84158 1.95999 9.84158 1.67593 9.64356 1.48656L8.23762 0.142028C8.0396 -0.0473428 7.74257 -0.0473428 7.54455 0.142028C7.34653 0.3314 7.34653 0.615456 7.54455 0.804827L8.11881 1.354H8C3.58416 1.354 0 4.78162 0 9.0046C0 11.4475 1.22772 13.7578 3.28713 15.1781C3.36634 15.2349 3.46535 15.2728 3.56436 15.2728C3.72277 15.2728 3.86139 15.216 3.9604 15.0834C4.11881 14.8751 4.07921 14.591 3.86139 14.4395C2.05941 13.1708 0.970297 11.1445 0.970297 9.0046Z"
        fill="#7A3DAA"
      />
      <path
        d="M15.9994 9.0049C15.9994 6.56202 14.7717 4.25169 12.7123 2.83141C12.4944 2.67991 12.1974 2.71778 12.039 2.92609C11.8806 3.1344 11.9202 3.41846 12.138 3.56995C13.94 4.83874 15.0291 6.86501 15.0291 9.0049C15.0291 12.7166 11.8806 15.7276 7.99938 15.7276H7.86077L8.43502 15.1784C8.63304 14.989 8.63304 14.705 8.43502 14.5156C8.23701 14.3262 7.93998 14.3262 7.74196 14.5156L6.33601 15.8601C6.138 16.0495 6.138 16.3336 6.33601 16.5229L7.74196 17.8675C7.84097 17.9622 7.95978 18 8.07859 18C8.1974 18 8.33601 17.9622 8.41522 17.8675C8.61324 17.6781 8.61324 17.394 8.41522 17.2047L7.84097 16.6555H7.99938C12.4152 16.6555 15.9994 13.2279 15.9994 9.0049Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function DesignElementsIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#EDF4FD" />
      <path
        d="M17.9567 7.71677C17.8781 7.72444 17.8027 7.7519 17.7375 7.7966C17.6723 7.84131 17.6196 7.90181 17.5842 7.97243L7.76557 27.6069C7.72937 27.6782 7.71203 27.7575 7.71522 27.8374C7.7184 27.9172 7.742 27.9949 7.78377 28.0631C7.82553 28.1312 7.88406 28.1875 7.95378 28.2265C8.02349 28.2656 8.10206 28.2862 8.18198 28.2863H27.8191C27.8991 28.2862 27.9776 28.2656 28.0474 28.2265C28.1171 28.1875 28.1756 28.1312 28.2174 28.0631C28.2591 27.9949 28.2827 27.9172 28.2859 27.8374C28.2891 27.7575 28.2718 27.6782 28.2356 27.6069L18.417 7.97243C18.3748 7.88853 18.3084 7.81927 18.2263 7.77368C18.1442 7.72808 18.0503 7.70825 17.9567 7.71677ZM18.0006 9.2215L22.1574 17.534H13.8437L18.0006 9.2215ZM14.0775 18.469H21.9236L18.0006 26.5113L14.0775 18.469ZM13.2009 18.8196L17.365 27.3513H8.93445L13.2009 18.8196ZM22.8003 18.8196L27.0667 27.3513H18.6361L22.8003 18.8196Z"
        fill="#1F71E1"
      />
    </svg>
  );
}

export function PendingIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346625 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9969 5.87922 15.1531 3.84619 13.6534 2.34657C12.1538 0.846946 10.1208 0.00309679 8 0ZM8.58537 8C8.5848 8.08332 8.5668 8.1656 8.53252 8.24155C8.49825 8.31749 8.44845 8.38543 8.38634 8.44097L5.26439 11.1727C5.20648 11.2239 5.13905 11.2633 5.06593 11.2885C4.99282 11.3136 4.91546 11.3242 4.83828 11.3195C4.76109 11.3148 4.68559 11.2949 4.61608 11.261C4.54657 11.2271 4.48442 11.1799 4.43317 11.1219C4.38193 11.064 4.34259 10.9966 4.3174 10.9235C4.29222 10.8504 4.28168 10.773 4.28639 10.6958C4.2911 10.6186 4.31097 10.5431 4.34486 10.4736C4.37875 10.4041 4.426 10.342 4.48391 10.2907L7.41464 7.73463V2.92683C7.41464 2.77158 7.47631 2.62269 7.58609 2.51291C7.69586 2.40314 7.84475 2.34146 8 2.34146C8.15525 2.34146 8.30414 2.40314 8.41392 2.51291C8.52369 2.62269 8.58537 2.77158 8.58537 2.92683V8Z"
        fill="#060606"
        fillOpacity="0.5"
      />
    </svg>
  );
}

export function ValidationIcon() {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.30511 13.5983C7.43712 13.6614 7.59114 13.7245 7.72315 13.7666C7.76716 13.7877 7.78916 13.8087 7.81116 13.8718L7.94317 15.0922C7.96518 15.2816 8.14119 15.4289 8.33921 15.4289H9.43932C9.63734 15.4289 9.81336 15.2816 9.83536 15.0922L9.96738 13.8718C9.96738 13.8298 10.0114 13.7877 10.0554 13.7666C10.2094 13.7245 10.3414 13.6614 10.4734 13.5983C10.5174 13.5773 10.5614 13.5773 10.6054 13.6193L11.6175 14.3979C11.7716 14.5241 12.0136 14.5031 12.1676 14.3768L12.9597 13.6193C13.1137 13.4721 13.1137 13.2616 12.9817 13.0933L12.1676 12.1254C12.1456 12.0833 12.1236 12.0412 12.1456 11.9992C12.2116 11.8729 12.2776 11.7256 12.3216 11.5994C12.3436 11.5573 12.3656 11.5363 12.4316 11.5152L13.7078 11.389C13.9058 11.3679 14.0598 11.1996 14.0598 11.0102V9.95817C14.0598 9.76879 13.9058 9.60046 13.7078 9.57942L12.4096 9.47422C12.3656 9.47422 12.3216 9.43213 12.2996 9.39005C12.2556 9.24276 12.1896 9.11652 12.1236 8.99027C12.1016 8.94819 12.1016 8.9061 12.1456 8.86402L12.9597 7.89612C13.0917 7.74884 13.0697 7.51738 12.9377 7.37009L12.1456 6.61261C11.9916 6.46532 11.7716 6.46532 11.5955 6.59157L10.5834 7.37009C10.5394 7.39113 10.4954 7.41218 10.4514 7.39113C10.3194 7.32801 10.1654 7.26489 10.0334 7.2228C9.98938 7.20176 9.96738 7.18072 9.94537 7.1176L9.81336 5.89721C9.79136 5.70784 9.61534 5.56055 9.41732 5.56055H8.31721C8.11919 5.56055 7.94317 5.70784 7.92117 5.89721L7.81116 7.13864C7.81116 7.18072 7.76716 7.2228 7.72315 7.24385C7.56914 7.28593 7.43712 7.34905 7.30511 7.41218C7.2611 7.43322 7.2171 7.43322 7.1731 7.39113L6.16099 6.61261C6.00698 6.48636 5.76495 6.5074 5.61094 6.63365L4.81886 7.39113C4.66484 7.53842 4.66484 7.74884 4.79686 7.91717L5.61094 8.88506C5.63294 8.92714 5.65494 8.96923 5.63294 9.01131C5.56694 9.13756 5.50093 9.28485 5.45692 9.41109C5.43492 9.45318 5.41292 9.47422 5.34691 9.49526L4.07079 9.62151C3.87277 9.64255 3.71875 9.81088 3.71875 10.0002V11.0523C3.71875 11.2417 3.87277 11.41 4.07079 11.4311L5.34691 11.5573C5.39092 11.5573 5.43492 11.5994 5.45692 11.6415C5.50093 11.7888 5.56694 11.915 5.63294 12.0412C5.65494 12.0833 5.65494 12.1254 5.61094 12.1675L4.79686 13.1354C4.66484 13.2827 4.68685 13.5141 4.81886 13.6614L5.61094 14.4189C5.76495 14.5662 5.98498 14.5662 6.16099 14.4399L7.1731 13.6614C7.2171 13.5983 7.2611 13.5773 7.30511 13.5983ZM8.88927 8.67465C9.94537 8.67465 10.8035 9.49526 10.8035 10.5052C10.8035 11.5152 9.94537 12.3358 8.88927 12.3358C7.83316 12.3358 6.97508 11.5152 6.97508 10.5052C6.97508 9.49526 7.83316 8.67465 8.88927 8.67465Z"
        fill="#7A3DAA"
      />
      <path
        d="M1.07811 10.5051C1.07811 6.38103 4.57646 3.03547 8.88889 3.03547H9.0429L8.40484 3.64567C8.18482 3.85608 8.18482 4.1717 8.40484 4.38211C8.51485 4.48731 8.64686 4.5294 8.77888 4.5294C8.91089 4.5294 9.06491 4.48731 9.15292 4.38211L10.7151 2.88818C10.9351 2.67777 10.9351 2.36215 10.7151 2.15174L9.15292 0.657809C8.93289 0.447397 8.60286 0.447397 8.38284 0.657809C8.16282 0.868222 8.16282 1.18384 8.38284 1.39425L9.0209 2.00445H8.88889C3.9824 2.00445 0 5.81291 0 10.5051C0 13.2194 1.36414 15.7865 3.65237 17.3646C3.74037 17.4277 3.85038 17.4698 3.9604 17.4698C4.13641 17.4698 4.29043 17.4066 4.40044 17.2593C4.57646 17.0279 4.53245 16.7123 4.29043 16.5439C2.28823 15.1342 1.07811 12.8828 1.07811 10.5051Z"
        fill="#7A3DAA"
      />
      <path
        d="M17.7771 10.5048C17.7771 7.79048 16.413 5.22345 14.1247 3.64536C13.8827 3.47703 13.5527 3.51911 13.3767 3.75056C13.2006 3.98202 13.2446 4.29763 13.4867 4.46596C15.4889 5.87573 16.699 8.12714 16.699 10.5048C16.699 14.6289 13.2006 17.9744 8.8882 17.9744H8.73419L9.37225 17.3642C9.59227 17.1538 9.59227 16.8382 9.37225 16.6278C9.15223 16.4174 8.8222 16.4174 8.60217 16.6278L7.04002 18.1217C6.81999 18.3321 6.81999 18.6478 7.04002 18.8582L8.60217 20.3521C8.71218 20.4573 8.8442 20.4994 8.97621 20.4994C9.10822 20.4994 9.26224 20.4573 9.35025 20.3521C9.57027 20.1417 9.57027 19.8261 9.35025 19.6157L8.71218 19.0055H8.8882C13.7947 19.0055 17.7771 15.197 17.7771 10.5048Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function YellowInfoIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM9.375 6.25C9.375 6.08424 9.44085 5.92527 9.55806 5.80806C9.67527 5.69085 9.83424 5.625 10 5.625C10.1658 5.625 10.3247 5.69085 10.4419 5.80806C10.5592 5.92527 10.625 6.08424 10.625 6.25V10.625C10.625 10.7908 10.5592 10.9497 10.4419 11.0669C10.3247 11.1842 10.1658 11.25 10 11.25C9.83424 11.25 9.67527 11.1842 9.55806 11.0669C9.44085 10.9497 9.375 10.7908 9.375 10.625V6.25ZM10 14.375C9.81458 14.375 9.63333 14.32 9.47916 14.217C9.32499 14.114 9.20482 13.9676 9.13387 13.7963C9.06291 13.625 9.04434 13.4365 9.08052 13.2546C9.11669 13.0727 9.20598 12.9057 9.33709 12.7746C9.4682 12.6435 9.63525 12.5542 9.81711 12.518C9.99896 12.4818 10.1875 12.5004 10.3588 12.5714C10.5301 12.6423 10.6765 12.7625 10.7795 12.9167C10.8825 13.0708 10.9375 13.2521 10.9375 13.4375C10.9375 13.6861 10.8387 13.9246 10.6629 14.1004C10.4871 14.2762 10.2486 14.375 10 14.375Z"
        fill="#A68B26"
      />
    </svg>
  );
}

export function NewProjectIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1424 5.60962L11.7578 0.225C11.6863 0.153589 11.6014 0.0969631 11.5081 0.0583569C11.4147 0.0197506 11.3146 -7.92199e-05 11.2136 2.37845e-07H1.9828C1.57477 2.37845e-07 1.18346 0.162088 0.894941 0.450605C0.606423 0.739123 0.444336 1.13044 0.444336 1.53846V18.4615C0.444336 18.8696 0.606423 19.2609 0.894941 19.5494C1.18346 19.8379 1.57477 20 1.9828 20H15.829C16.237 20 16.6283 19.8379 16.9168 19.5494C17.2053 19.2609 17.3674 18.8696 17.3674 18.4615V6.15385C17.3675 6.0528 17.3477 5.95273 17.3091 5.85935C17.2705 5.76597 17.2138 5.68111 17.1424 5.60962ZM11.2136 6.15385V1.92308L15.4443 6.15385H11.2136Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function NewUploadIcon({ fill = "black" }) {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9996 8.00015V11.5C11.9996 11.7652 11.8943 12.0196 11.7067 12.2071C11.5192 12.3946 11.2648 12.5 10.9996 12.5H0.999967C0.734759 12.5 0.480414 12.3946 0.292884 12.2071C0.105353 12.0196 0 11.7652 0 11.5V8.00015C0 7.86754 0.0526768 7.74037 0.146442 7.64661C0.240207 7.55284 0.36738 7.50016 0.499984 7.50016C0.632588 7.50016 0.75976 7.55284 0.853525 7.64661C0.94729 7.74037 0.999967 7.86754 0.999967 8.00015V11.5H10.9996V8.00015C10.9996 7.86754 11.0523 7.74037 11.1461 7.64661C11.2398 7.55284 11.367 7.50016 11.4996 7.50016C11.6322 7.50016 11.7594 7.55284 11.8532 7.64661C11.9469 7.74037 11.9996 7.86754 11.9996 8.00015ZM3.85362 3.85403L5.49982 2.20721V8.00015C5.49982 8.13275 5.5525 8.25992 5.64626 8.35369C5.74003 8.44746 5.8672 8.50013 5.9998 8.50013C6.13241 8.50013 6.25958 8.44746 6.35335 8.35369C6.44711 8.25992 6.49979 8.13275 6.49979 8.00015V2.20721L8.14598 3.85403C8.2398 3.94785 8.36704 4.00056 8.49972 4.00056C8.6324 4.00056 8.75964 3.94785 8.85346 3.85403C8.94728 3.76022 8.99998 3.63297 8.99998 3.5003C8.99998 3.36762 8.94728 3.24037 8.85346 3.14656L6.35354 0.646638C6.30711 0.600152 6.25196 0.563274 6.19127 0.538112C6.13057 0.512951 6.06551 0.5 5.9998 0.5C5.9341 0.5 5.86904 0.512951 5.80834 0.538112C5.74764 0.563274 5.6925 0.600152 5.64607 0.646638L3.14615 3.14656C3.05233 3.24037 2.99962 3.36762 2.99962 3.5003C2.99962 3.63297 3.05233 3.76022 3.14615 3.85403C3.23996 3.94785 3.36721 4.00056 3.49989 4.00056C3.63256 4.00056 3.75981 3.94785 3.85362 3.85403Z"
        fill={fill}
      />
    </svg>
  );
}

export function DownloadAsPDFIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8.75V12.8333C14 13.1428 13.8771 13.4395 13.6583 13.6583C13.4395 13.8771 13.1428 14 12.8333 14H1.16667C0.857247 14 0.560501 13.8771 0.341709 13.6583C0.122916 13.4395 0 13.1428 0 12.8333V8.75C0 8.59529 0.0614583 8.44692 0.170854 8.33752C0.280251 8.22812 0.428624 8.16667 0.583333 8.16667C0.738043 8.16667 0.886416 8.22812 0.995812 8.33752C1.10521 8.44692 1.16667 8.59529 1.16667 8.75V12.8333H12.8333V8.75C12.8333 8.59529 12.8948 8.44692 13.0042 8.33752C13.1136 8.22812 13.262 8.16667 13.4167 8.16667C13.5714 8.16667 13.7197 8.22812 13.8291 8.33752C13.9385 8.44692 14 8.59529 14 8.75ZM6.58729 9.16271C6.64147 9.21694 6.7058 9.25997 6.77662 9.28933C6.84743 9.31868 6.92334 9.33379 7 9.33379C7.07666 9.33379 7.15257 9.31868 7.22338 9.28933C7.2942 9.25997 7.35853 9.21694 7.41271 9.16271L10.3294 6.24604C10.3836 6.19184 10.4266 6.1275 10.4559 6.05669C10.4852 5.98588 10.5003 5.90998 10.5003 5.83333C10.5003 5.75669 10.4852 5.68079 10.4559 5.60998C10.4266 5.53916 10.3836 5.47482 10.3294 5.42062C10.2752 5.36643 10.2108 5.32343 10.14 5.2941C10.0692 5.26477 9.99331 5.24968 9.91667 5.24968C9.84002 5.24968 9.76412 5.26477 9.69331 5.2941C9.6225 5.32343 9.55816 5.36643 9.50396 5.42062L7.58333 7.34198V0.583333C7.58333 0.428624 7.52188 0.280251 7.41248 0.170854C7.30308 0.0614583 7.15471 0 7 0C6.84529 0 6.69692 0.0614583 6.58752 0.170854C6.47812 0.280251 6.41667 0.428624 6.41667 0.583333V7.34198L4.49604 5.42062C4.38658 5.31117 4.23813 5.24968 4.08333 5.24968C3.92854 5.24968 3.78008 5.31117 3.67062 5.42062C3.56117 5.53008 3.49968 5.67854 3.49968 5.83333C3.49968 5.98813 3.56117 6.13658 3.67062 6.24604L6.58729 9.16271Z"
        fill="black"
      />
    </svg>
  );
}

export function CheckIcon({ fill = "#7A3DAA", width = 12, height = 9 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29781 8.5L0.893555 5.09575L2.08504 3.90426L4.29781 6.11702L9.91483 0.5L11.1063 1.69149L4.29781 8.5Z"
        fill={fill}
      />
    </svg>
  );
}

export function BulbIcon() {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.86194 0.69759C12.1924 1.2077 14.2028 2.75803 15.243 4.85845C17.2634 8.91921 15.313 13.3301 12.2124 15.4205V16.1207C12.2224 16.3907 12.2324 16.8908 11.8523 17.2809C11.5723 17.5609 11.1622 17.711 10.6221 17.711H5.49109C5.08099 17.711 4.56088 17.6709 4.21082 17.3109C3.87076 16.9608 3.88075 16.5307 3.89077 16.2507V15.4205C1.5503 13.8502 0 11.1397 0 8.54916C0 6.09869 1.09021 3.80821 3.01058 2.27792C4.92096 0.737616 7.42146 0.157521 9.86194 0.69759Z"
        fill="#DEA028"
      />
      <path
        d="M11.2214 20.4959C11.2455 20.4986 11.2692 20.5 11.2915 20.5C11.5916 20.5 11.8717 20.3 11.9717 19.9899C12.0817 19.6198 11.8617 19.2398 11.4916 19.1298C9.23112 18.4896 6.85067 18.4896 4.59021 19.1298C4.22013 19.2298 4.00009 19.6198 4.11012 19.9899C4.21014 20.36 4.60022 20.57 4.9703 20.47C6.98069 19.8999 9.0911 19.8999 11.1015 20.47C11.1392 20.4826 11.1808 20.4912 11.2214 20.4959Z"
        fill="#DEA028"
      />
    </svg>
  );
}

export function DownMenuIcon({ fill = "#536787" }) {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M5.77064 5.68539C5.34503 6.10487 4.65497 6.10487 4.22936 5.68539L0.321395 1.8337C-0.365172 1.15702 0.121081 4.37119e-07 1.09203 3.88817e-07L8.90797 0C9.87892 -4.83017e-08 10.3652 1.15702 9.67861 1.8337L5.77064 5.68539Z"
        fill={fill}
      />
    </svg>
  );
}

export function StumiliDetailsLogoIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.19391 2.48752C3.07555 1.98735 4.08897 1.7009 5.19053 1.7009C6.80874 1.7009 8.32581 2.3583 9.38776 3.42026C10.3004 4.33292 10.9068 5.48381 11.0952 6.78918C11.1365 7.07503 11.1577 7.3683 11.1577 7.66809C11.1577 7.9715 11.1071 8.32549 11.0565 8.62891C11.2159 8.33011 11.3517 8.00778 11.4578 7.66809C11.5456 7.38714 11.613 7.09433 11.6566 6.79314C11.6941 6.53398 11.7139 6.26863 11.7139 5.9993C11.7139 2.86399 9.13492 0.284954 5.99963 0.284954C4.35515 0.284954 2.88758 0.967328 1.84706 2.04621C1.46837 2.43885 1.14625 2.88401 0.892749 3.3679C0.892477 3.36843 0.892204 3.36895 0.891931 3.36947C0.856976 3.43624 0.823327 3.50375 0.791015 3.57197L0.942723 3.42026C1.32087 3.05929 1.73992 2.74507 2.19391 2.48752ZM3.93783 1.26221C4.34155 1.18556 4.75988 1.14534 5.19053 1.14534C6.95725 1.14534 8.6153 1.86211 9.7806 3.02742C10.2599 3.50669 10.6624 4.04767 10.9739 4.63939C10.3705 2.46093 8.35825 0.840509 5.99963 0.840509C5.26402 0.840509 4.56763 0.991503 3.93783 1.26221Z"
        fill="#B946E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.03716 3.82406C8.80354 3.5692 8.54316 3.35003 8.25978 3.15903C7.9407 2.94399 7.59244 2.76467 7.22036 2.6104C7.18325 2.59501 7.1459 2.57987 7.10832 2.56497C7.06053 2.54602 7.01236 2.52746 6.96383 2.50926C6.98314 2.52857 7.00246 2.54051 7.01896 2.55071C7.04565 2.56721 7.06496 2.57914 7.06496 2.6104C7.36517 2.89695 7.63223 3.21665 7.86218 3.56253C8.4844 4.49846 8.83488 5.6261 8.83488 6.80766C8.83488 8.47645 8.17749 9.99353 7.06497 11.0555C7.0625 11.058 7.06003 11.0604 7.05756 11.0629C6.80718 11.3123 6.55631 11.5126 6.25586 11.7129C6.62394 11.7006 6.98309 11.6526 7.3297 11.5725C8.41167 11.3225 9.37142 10.7595 10.0991 9.99353C10.4531 9.28556 10.6048 8.47645 10.6048 7.66734C10.6048 6.15026 9.99797 4.78488 9.03716 3.82406ZM9.63815 9.67109C9.92044 9.07301 10.0492 8.38074 10.0492 7.66734C10.0492 6.5096 9.6574 5.45421 9.01643 4.63691C9.26031 5.32143 9.39044 6.05503 9.39044 6.80766C9.39044 8.27706 8.9215 9.64686 8.09312 10.736C8.67808 10.4787 9.20231 10.1144 9.63815 9.67109Z"
        fill="#B946E0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.00183 7.28683C0.768808 6.88409 0.582451 6.45365 0.442754 5.99855C0.382066 5.80084 0.330185 5.59848 0.287109 5.39172L0.287109 5.99855C0.287109 6.51695 0.355038 7.01956 0.48252 7.49771C1.07631 9.72485 2.9621 11.4215 5.29345 11.7129C5.76008 11.4329 6.22672 11.1529 6.61388 10.7935C6.64629 10.7634 6.67814 10.7327 6.70939 10.7015C6.78524 10.6004 6.86109 10.5119 6.93695 10.4234C7.0128 10.3349 7.08865 10.2464 7.16451 10.1452C6.88148 10.2261 6.63078 10.2423 6.36071 10.2456C6.29301 10.2464 6.22408 10.2464 6.15313 10.2464C4.53491 10.2464 3.01784 9.58898 1.95589 8.52702C1.5798 8.15092 1.26178 7.73612 1.00183 7.28683ZM2.08418 9.38519C2.85997 10.297 3.94421 10.9349 5.17642 11.1349C5.37077 11.0174 5.5537 10.904 5.72388 10.7878C4.36583 10.6984 3.0924 10.1888 2.08418 9.38519Z"
        fill="#B946E0"
      />
    </svg>
  );
}

export function StumiliDetailsPackagingIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7143 3.29392C11.7132 3.24585 11.6982 3.19913 11.671 3.15947C11.6438 3.11981 11.6057 3.08894 11.5612 3.07061L6.096 0.826967C6.03616 0.802469 5.9691 0.802469 5.90927 0.826967L0.443085 3.06965C0.391103 3.08984 0.347585 3.12719 0.319748 3.17551C0.291912 3.22383 0.281431 3.28021 0.290043 3.33531C0.28964 3.34332 0.28964 3.35136 0.290043 3.35937V10.4667C0.289946 10.5142 0.303617 10.5608 0.329408 10.6008C0.355198 10.6407 0.392004 10.6724 0.435384 10.6919L5.82071 13.1098L5.84189 13.1165L5.85921 13.1223C5.89975 13.1342 5.94285 13.1342 5.98338 13.1223L5.99974 13.1175L6.01996 13.1107L11.567 10.6929C11.6111 10.6737 11.6486 10.6421 11.6749 10.6019C11.7012 10.5617 11.7153 10.5147 11.7152 10.4667V3.35937C11.7156 3.35136 11.7156 3.34332 11.7152 3.33531C11.7161 3.32151 11.7157 3.30766 11.7143 3.29392ZM4.39906 2.02146L9.11544 4.09282L8.03067 4.58659L3.3143 2.48732L4.39906 2.02146ZM9.50045 4.4836V7.58967L8.27804 8.11906L8.279 5.01876L9.50045 4.4836ZM6.00263 1.32171L10.847 3.31124L9.72279 3.81946L4.9862 1.73848L6.00263 1.32171ZM2.60877 2.71352L7.42043 4.85129L5.96894 5.48944L1.15632 3.31124L2.60877 2.71352ZM0.779969 3.73957L5.67537 5.93701V12.5043L0.782856 10.3078L0.779969 3.73957ZM11.2214 10.3059L6.16819 12.5091V5.97359L7.78619 5.2363L7.79774 8.49348C7.79787 8.53429 7.80813 8.57444 7.82761 8.6103C7.84709 8.64617 7.87517 8.67663 7.90933 8.69896C7.94349 8.72129 7.98267 8.73479 8.02334 8.73824C8.064 8.74168 8.10489 8.73497 8.14232 8.71871L9.85658 7.9766C9.90083 7.95761 9.93855 7.92606 9.96506 7.88586C9.99158 7.84566 10.0057 7.79857 10.0058 7.75041V4.26799L11.2272 3.73572L11.2214 10.3059Z"
        fill="#89A318"
      />
    </svg>
  );
}

export function StimuliDetailsDesignElementsIcon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.97656 0.501032C5.93451 0.505131 5.89418 0.519813 5.85934 0.543719C5.8245 0.567625 5.79629 0.599974 5.77734 0.637736L0.527125 11.1367C0.507766 11.1748 0.498495 11.2173 0.500199 11.26C0.501902 11.3027 0.514522 11.3442 0.536854 11.3806C0.559187 11.4171 0.590486 11.4472 0.627764 11.4681C0.665042 11.489 0.707054 11.5 0.74979 11.5H11.2502C11.293 11.5 11.335 11.489 11.3722 11.4681C11.4095 11.4472 11.4408 11.4171 11.4632 11.3806C11.4855 11.3442 11.4981 11.3027 11.4998 11.26C11.5015 11.2173 11.4922 11.1748 11.4729 11.1367L6.22267 0.637736C6.20012 0.592875 6.16458 0.555841 6.12069 0.531458C6.07679 0.507076 6.02657 0.496475 5.97656 0.501032ZM6 1.30564L8.22275 5.75054H3.77726L6 1.30564ZM3.90226 6.2505H8.09774L6 10.5509L3.90226 6.2505ZM3.43349 6.43798L5.66015 11H1.15215L3.43349 6.43798ZM8.56651 6.43798L10.8479 11H6.33986L8.56651 6.43798Z"
        fill="#1F71E1"
      />
    </svg>
  );
}

export function InsightsStarsIcon({ fill }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7054 0L15.9764 3.43486L19.4113 4.70588L15.9764 5.97689L14.7054 9.41176L13.4344 5.97689L9.99952 4.70588L13.4344 3.43486L14.7054 0ZM7.64671 4.70588L9.55323 9.85818L14.7055 11.7647L9.55323 13.6712L7.64671 18.8235L5.74019 13.6712L0.587891 11.7647L5.74019 9.85818L7.64671 4.70588ZM16.088 16.2644L15.2936 14.1177L14.4992 16.2644L12.3524 17.0588L14.4992 17.8532L15.2936 20L16.088 17.8532L18.2347 17.0588L16.088 16.2644Z"
        fill={fill}
      />
    </svg>
  );
}

export function AiPersonaInterviewsIcon({ fill }) {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0275 0H1.79675C1.42953 0 1.07734 0.140476 0.817678 0.390524C0.558013 0.640573 0.412134 0.979711 0.412134 1.33333V14.6667C0.410538 14.9209 0.48523 15.1702 0.627234 15.3846C0.769238 15.5989 0.972509 15.7692 1.21261 15.875C1.39558 15.957 1.59492 15.9997 1.79675 16C2.12179 15.9993 2.43605 15.8877 2.68377 15.685C2.68789 15.6824 2.69167 15.6793 2.69502 15.6758L5.47463 13.3333H17.0275C17.3947 13.3333 17.7469 13.1929 18.0066 12.9428C18.2662 12.6928 18.4121 12.3536 18.4121 12V1.33333C18.4121 0.979711 18.2662 0.640573 18.0066 0.390524C17.7469 0.140476 17.3947 0 17.0275 0ZM5.60443 7.66667C5.39905 7.66667 5.19827 7.60802 5.0275 7.49814C4.85672 7.38825 4.72362 7.23208 4.64502 7.04935C4.56642 6.86662 4.54586 6.66556 4.58593 6.47158C4.626 6.2776 4.7249 6.09941 4.87013 5.95956C5.01536 5.81971 5.2004 5.72447 5.40184 5.68588C5.60328 5.6473 5.81208 5.6671 6.00184 5.74279C6.19159 5.81847 6.35378 5.94665 6.46788 6.1111C6.58199 6.27555 6.6429 6.46889 6.6429 6.66667C6.6429 6.93188 6.53349 7.18624 6.33874 7.37377C6.14399 7.56131 5.87985 7.66667 5.60443 7.66667ZM9.41212 7.66667C9.20673 7.66667 9.00596 7.60802 8.83519 7.49814C8.66441 7.38825 8.53131 7.23208 8.45271 7.04935C8.37411 6.86662 8.35355 6.66556 8.39362 6.47158C8.43369 6.2776 8.53259 6.09941 8.67782 5.95956C8.82305 5.81971 9.00809 5.72447 9.20953 5.68588C9.41097 5.6473 9.61977 5.6671 9.80952 5.74279C9.99928 5.81847 10.1615 5.94665 10.2756 6.1111C10.3897 6.27555 10.4506 6.46889 10.4506 6.66667C10.4506 6.93188 10.3412 7.18624 10.1464 7.37377C9.95167 7.56131 9.68754 7.66667 9.41212 7.66667ZM13.2198 7.66667C13.0144 7.66667 12.8136 7.60802 12.6429 7.49814C12.4721 7.38825 12.339 7.23208 12.2604 7.04935C12.1818 6.86662 12.1612 6.66556 12.2013 6.47158C12.2414 6.2776 12.3403 6.09941 12.4855 5.95956C12.6307 5.81971 12.8158 5.72447 13.0172 5.68588C13.2187 5.6473 13.4275 5.6671 13.6172 5.74279C13.807 5.81847 13.9691 5.94665 14.0833 6.1111C14.1974 6.27555 14.2583 6.46889 14.2583 6.66667C14.2583 6.93188 14.1489 7.18624 13.9541 7.37377C13.7594 7.56131 13.4952 7.66667 13.2198 7.66667Z"
        fill={fill}
      />
    </svg>
  );
}

export function CompareIcon({ fill }) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41211 7.69306C7.7427 7.69306 7.08832 7.49456 6.53172 7.12265C5.97512 6.75074 5.54131 6.22214 5.28513 5.60368C5.02896 4.98522 4.96193 4.30469 5.09253 3.64814C5.22313 2.99159 5.54548 2.38851 6.01883 1.91516C6.49217 1.44181 7.09525 1.11946 7.7518 0.988864C8.40836 0.858268 9.08889 0.925295 9.70735 1.18147C10.3258 1.43764 10.8544 1.87146 11.2263 2.42805C11.5982 2.98465 11.7967 3.63903 11.7967 4.30844C11.7957 5.20579 11.4388 6.06609 10.8043 6.7006C10.1698 7.33512 9.30945 7.69204 8.41211 7.69306ZM13.0275 8.30844C12.3581 8.30844 11.7037 8.50695 11.1471 8.87886C10.5905 9.25076 10.1567 9.77937 9.90052 10.3978C9.64435 11.0163 9.57732 11.6968 9.70791 12.3534C9.83851 13.0099 10.1609 13.613 10.6342 14.0863C11.1076 14.5597 11.7106 14.882 12.3672 15.0126C13.0237 15.1432 13.7043 15.0762 14.3227 14.82C14.9412 14.5639 15.4698 14.13 15.8417 13.5734C16.2136 13.0169 16.4121 12.3625 16.4121 11.6931C16.4111 10.7957 16.0542 9.93542 15.4197 9.3009C14.7851 8.66638 13.9248 8.30946 13.0275 8.30844ZM3.79673 8.30844C3.12731 8.30844 2.47293 8.50695 1.91633 8.87886C1.35974 9.25076 0.925923 9.77937 0.669749 10.3978C0.413576 11.0163 0.346549 11.6968 0.477145 12.3534C0.607741 13.0099 0.930095 13.613 1.40344 14.0863C1.87679 14.5597 2.47987 14.882 3.13642 15.0126C3.79297 15.1432 4.47351 15.0762 5.09196 14.82C5.71042 14.5639 6.23902 14.13 6.61093 13.5734C6.98284 13.0169 7.18134 12.3625 7.18134 11.6931C7.18032 10.7957 6.8234 9.93542 6.18889 9.3009C5.55437 8.66638 4.69407 8.30946 3.79673 8.30844Z"
        fill={fill}
      />
    </svg>
  );
}

export function CLoseIcon({ stroke = "#899BB6" }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 1L5 5M5 5L1 9M5 5L9 9M5 5L1 1"
        stroke={stroke}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function CaptureIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 1V6C24 6.26522 23.8946 6.51957 23.7071 6.70711C23.5196 6.89464 23.2652 7 23 7C22.7348 7 22.4804 6.89464 22.2929 6.70711C22.1054 6.51957 22 6.26522 22 6V2H18C17.7348 2 17.4804 1.89464 17.2929 1.70711C17.1054 1.51957 17 1.26522 17 1C17 0.734784 17.1054 0.48043 17.2929 0.292893C17.4804 0.105357 17.7348 0 18 0H23C23.2652 0 23.5196 0.105357 23.7071 0.292893C23.8946 0.48043 24 0.734784 24 1ZM6 22H2V18C2 17.7348 1.89464 17.4804 1.70711 17.2929C1.51957 17.1054 1.26522 17 1 17C0.734784 17 0.48043 17.1054 0.292893 17.2929C0.105357 17.4804 0 17.7348 0 18V23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24H6C6.26522 24 6.51957 23.8946 6.70711 23.7071C6.89464 23.5196 7 23.2652 7 23C7 22.7348 6.89464 22.4804 6.70711 22.2929C6.51957 22.1054 6.26522 22 6 22ZM23 17C22.7348 17 22.4804 17.1054 22.2929 17.2929C22.1054 17.4804 22 17.7348 22 18V22H18C17.7348 22 17.4804 22.1054 17.2929 22.2929C17.1054 22.4804 17 22.7348 17 23C17 23.2652 17.1054 23.5196 17.2929 23.7071C17.4804 23.8946 17.7348 24 18 24H23C23.2652 24 23.5196 23.8946 23.7071 23.7071C23.8946 23.5196 24 23.2652 24 23V18C24 17.7348 23.8946 17.4804 23.7071 17.2929C23.5196 17.1054 23.2652 17 23 17ZM1 7C1.26522 7 1.51957 6.89464 1.70711 6.70711C1.89464 6.51957 2 6.26522 2 6V2H6C6.26522 2 6.51957 1.89464 6.70711 1.70711C6.89464 1.51957 7 1.26522 7 1C7 0.734784 6.89464 0.48043 6.70711 0.292893C6.51957 0.105357 6.26522 0 6 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7ZM19 17V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17Z"
        fill="white"
      />
    </svg>
  );
}

export function InfoIcon2({ fill = "#DEA028" }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C5.61553 0 4.26216 0.410543 3.11101 1.17971C1.95987 1.94888 1.06266 3.04213 0.532846 4.32122C0.00303299 5.6003 -0.13559 7.00776 0.134506 8.36563C0.404603 9.7235 1.07129 10.9708 2.05026 11.9497C3.02922 12.9287 4.2765 13.5954 5.63437 13.8655C6.99224 14.1356 8.3997 13.997 9.67879 13.4672C10.9579 12.9373 12.0511 12.0401 12.8203 10.889C13.5895 9.73785 14 8.38447 14 7C13.998 5.14409 13.2599 3.36475 11.9476 2.05242C10.6353 0.740087 8.85592 0.00195988 7 0ZM6.46154 3.76923C6.46154 3.62642 6.51827 3.48946 6.61925 3.38848C6.72023 3.2875 6.85719 3.23077 7 3.23077C7.14281 3.23077 7.27977 3.2875 7.38075 3.38848C7.48173 3.48946 7.53846 3.62642 7.53846 3.76923V7.53846C7.53846 7.68127 7.48173 7.81823 7.38075 7.91921C7.27977 8.02019 7.14281 8.07692 7 8.07692C6.85719 8.07692 6.72023 8.02019 6.61925 7.91921C6.51827 7.81823 6.46154 7.68127 6.46154 7.53846V3.76923ZM7 10.7692C6.84026 10.7692 6.6841 10.7219 6.55127 10.6331C6.41845 10.5444 6.31492 10.4182 6.25379 10.2706C6.19266 10.123 6.17666 9.96064 6.20783 9.80396C6.23899 9.64729 6.31592 9.50337 6.42888 9.39041C6.54183 9.27745 6.68575 9.20053 6.84243 9.16936C6.99911 9.1382 7.16151 9.15419 7.30909 9.21533C7.45668 9.27646 7.58282 9.37998 7.67157 9.51281C7.76032 9.64563 7.80769 9.80179 7.80769 9.96154C7.80769 10.1757 7.7226 10.3812 7.57113 10.5327C7.41965 10.6841 7.21422 10.7692 7 10.7692Z"
        fill={fill}
      />
    </svg>
  );
}

export function PdfIcon() {
  return (
    <svg
      width="36"
      height="45"
      viewBox="0 0 36 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_2165_9609)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.53082 0.5C1.5808 0.5 0 2.07596 0 4.02V40.98C0 42.924 1.5808 44.5 3.53082 44.5H32.2187C34.1688 44.5 35.7496 42.924 35.7496 40.98V4.02C35.7496 3.99703 35.7493 3.97412 35.7489 3.95125V11.5L24.7151 0.5H3.53082Z"
          fill="#FA4E4E"
        />
      </g>
      <path
        d="M25.0426 30.1322C23.5533 30.0219 22.1195 29.4705 20.9612 28.478C18.6998 28.9741 16.5485 29.6908 14.3975 30.5733C12.6878 33.6057 11.0881 35.1495 9.7092 35.1495C9.43335 35.1495 9.10261 35.0945 8.88193 34.929C8.27507 34.6534 7.94434 34.0468 7.94434 33.4404C7.94434 32.944 8.05467 31.5657 13.2944 29.305C14.5081 27.0995 15.4454 24.839 16.2178 22.4682C15.5557 21.1449 14.1219 17.8916 15.1144 16.2378C15.4454 15.6311 16.1074 15.3003 16.8246 15.3556C17.376 15.3556 17.9275 15.6311 18.2585 16.0722C18.9757 17.0647 18.9205 19.1599 17.9826 22.2476C18.8653 23.8994 20.0215 25.3907 21.4023 26.6586C22.5608 26.4378 23.7188 26.2725 24.8771 26.2725C27.4695 26.3275 27.8557 27.5406 27.8005 28.2575C27.8005 30.1322 25.9802 30.1322 25.0426 30.1322ZM9.59913 33.5504L9.76464 33.4954C10.5367 33.2199 11.1433 32.6685 11.5847 31.9516C10.7571 32.2824 10.0954 32.8338 9.59913 33.5507V33.5504ZM16.9347 17.0097H16.7692C16.714 17.0097 16.6037 17.0097 16.5485 17.0647C16.3278 18.0019 16.4933 18.9944 16.8795 19.8766C17.2105 18.9394 17.2105 17.9469 16.9347 17.0097ZM17.3209 25.0045L17.2657 25.1145L17.2105 25.0595C16.714 26.3278 16.1623 27.5958 15.5557 28.8089L15.6661 28.7539V28.8639C16.8926 28.4205 18.1452 28.0523 19.4167 27.7611L19.3616 27.7061H19.5271C18.6995 26.8789 17.9275 25.9417 17.3209 25.0045ZM24.8219 27.9267C24.3254 27.9267 23.8843 27.9267 23.3878 28.0367C23.9395 28.3125 24.4912 28.4228 25.0426 28.478C25.4288 28.533 25.815 28.478 26.1457 28.3678C26.1457 28.2022 25.925 27.9267 24.8219 27.9267Z"
        fill="white"
      />
      <path
        d="M34.7132 10.4688H25.749L35.7484 20.4375V11.5L34.7132 10.4688Z"
        fill="url(#paint0_linear_2165_9609)"
      />
      <path
        d="M28.2457 11.5L35.7487 11.5L24.7148 0.5L24.7148 7.98C24.7148 9.92404 26.2956 11.5 28.2457 11.5Z"
        fill="#FDB8B8"
      />
      <defs>
        <filter
          id="filter0_i_2165_9609"
          x="0"
          y="0"
          width="35.75"
          height="44.5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.5" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2165_9609"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2165_9609"
          x1="27.9903"
          y1="8.23438"
          x2="37.959"
          y2="18.2337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.2" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function MessageIcon() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5385 0H1.21156C0.890239 0 0.58208 0.122916 0.354873 0.341709C0.127666 0.560501 2.19397e-05 0.857247 2.19397e-05 1.16667V12.8333C-0.00137517 13.0558 0.063981 13.2739 0.188234 13.4615C0.312488 13.6491 0.49035 13.7981 0.700442 13.8906C0.860538 13.9624 1.03496 13.9997 1.21156 14C1.49597 13.9993 1.77095 13.9017 1.9877 13.7244C1.99131 13.7221 1.99462 13.7194 1.99754 13.7164L4.4297 11.6667H14.5385C14.8598 11.6667 15.1679 11.5437 15.3951 11.325C15.6224 11.1062 15.75 10.8094 15.75 10.5V1.16667C15.75 0.857247 15.6224 0.560501 15.3951 0.341709C15.1679 0.122916 14.8598 0 14.5385 0ZM4.54328 6.70833C4.36357 6.70833 4.18789 6.65701 4.03846 6.56087C3.88904 6.46472 3.77257 6.32807 3.7038 6.16818C3.63503 6.0083 3.61703 5.83236 3.65209 5.66263C3.68715 5.4929 3.77369 5.33699 3.90077 5.21461C4.02785 5.09224 4.18975 5.00891 4.36602 4.97515C4.54228 4.94138 4.72498 4.95871 4.89101 5.02494C5.05705 5.09117 5.19896 5.20332 5.2988 5.34721C5.39865 5.4911 5.45194 5.66027 5.45194 5.83333C5.45194 6.0654 5.3562 6.28796 5.1858 6.45205C5.01539 6.61615 4.78427 6.70833 4.54328 6.70833ZM7.87501 6.70833C7.6953 6.70833 7.51962 6.65701 7.37019 6.56087C7.22076 6.46472 7.1043 6.32807 7.03553 6.16818C6.96675 6.0083 6.94876 5.83236 6.98382 5.66263C7.01888 5.4929 7.10542 5.33699 7.2325 5.21461C7.35957 5.09224 7.52148 5.00891 7.69774 4.97515C7.874 4.94138 8.0567 4.95871 8.22274 5.02494C8.38877 5.09117 8.53068 5.20332 8.63053 5.34721C8.73037 5.4911 8.78366 5.66027 8.78366 5.83333C8.78366 6.0654 8.68793 6.28796 8.51752 6.45205C8.34712 6.61615 8.116 6.70833 7.87501 6.70833ZM11.2067 6.70833C11.027 6.70833 10.8513 6.65701 10.7019 6.56087C10.5525 6.46472 10.436 6.32807 10.3673 6.16818C10.2985 6.0083 10.2805 5.83236 10.3155 5.66263C10.3506 5.4929 10.4371 5.33699 10.5642 5.21461C10.6913 5.09224 10.8532 5.00891 11.0295 4.97515C11.2057 4.94138 11.3884 4.95871 11.5545 5.02494C11.7205 5.09117 11.8624 5.20332 11.9623 5.34721C12.0621 5.4911 12.1154 5.66027 12.1154 5.83333C12.1154 6.0654 12.0197 6.28796 11.8493 6.45205C11.6788 6.61615 11.4477 6.70833 11.2067 6.70833Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function InfoIcon3({ fill = "#DEA028" }) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.5C6.41775 0.5 4.87103 0.969192 3.55544 1.84824C2.23985 2.72729 1.21447 3.97672 0.608967 5.43853C0.00346628 6.90034 -0.15496 8.50887 0.153721 10.0607C0.462403 11.6126 1.22433 13.038 2.34315 14.1569C3.46197 15.2757 4.88743 16.0376 6.43928 16.3463C7.99113 16.655 9.59966 16.4965 11.0615 15.891C12.5233 15.2855 13.7727 14.2602 14.6518 12.9446C15.5308 11.629 16 10.0822 16 8.5C15.9978 6.37895 15.1542 4.34542 13.6544 2.84562C12.1546 1.34581 10.121 0.50224 8 0.5ZM7.38462 4.80769C7.38462 4.64448 7.44945 4.48796 7.56486 4.37255C7.68027 4.25714 7.83679 4.19231 8 4.19231C8.16321 4.19231 8.31974 4.25714 8.43514 4.37255C8.55055 4.48796 8.61539 4.64448 8.61539 4.80769V9.11538C8.61539 9.27859 8.55055 9.43512 8.43514 9.55053C8.31974 9.66593 8.16321 9.73077 8 9.73077C7.83679 9.73077 7.68027 9.66593 7.56486 9.55053C7.44945 9.43512 7.38462 9.27859 7.38462 9.11538V4.80769ZM8 12.8077C7.81743 12.8077 7.63897 12.7536 7.48717 12.6521C7.33537 12.5507 7.21706 12.4065 7.14719 12.2379C7.07732 12.0692 7.05904 11.8836 7.09466 11.7045C7.13028 11.5255 7.21819 11.361 7.34729 11.2319C7.47638 11.1028 7.64086 11.0149 7.81992 10.9793C7.99898 10.9437 8.18458 10.9619 8.35325 11.0318C8.52192 11.1017 8.66608 11.22 8.76751 11.3718C8.86894 11.5236 8.92308 11.702 8.92308 11.8846C8.92308 12.1294 8.82583 12.3642 8.65271 12.5373C8.4796 12.7104 8.24482 12.8077 8 12.8077Z"
        fill={fill}
      />
    </svg>
  );
}

export function DeepDiveIcon() {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 4.7H1.4C0.630273 4.7 0 4.06973 0 3.3V1.9C0 1.13027 0.630273 0.5 1.4 0.5H3.5C3.69141 0.5 3.87324 0.538281 4.03867 0.608008C4.54316 0.820605 4.9 1.321 4.9 1.9V2.075H9.8V2.04014C9.8 1.80498 9.89707 1.5917 10.0543 1.43926C10.2061 1.2916 10.4125 1.2 10.6395 1.2H13.1605C13.2303 1.2 13.2986 1.20889 13.3643 1.22529C13.4654 1.25059 13.5598 1.29502 13.6432 1.35381C13.8592 1.50625 14 1.75781 14 2.04014V3.15986C14 3.33076 13.948 3.49072 13.8592 3.62402C13.7088 3.85029 13.4518 4 13.1605 4H10.6395C10.1773 4 9.8 3.62197 9.8 3.15986V3.125H7.875V7.325H9.8V7.29014C9.8 6.82803 10.1773 6.45 10.6395 6.45H13.1605C13.6227 6.45 14 6.82803 14 7.29014V8.40986C14 8.87197 13.6227 9.25 13.1605 9.25H10.6395C10.1773 9.25 9.8 8.87197 9.8 8.40986V8.375H7.875V11.7C7.875 12.1833 8.26738 12.575 8.75 12.575H9.8V12.5401C9.8 12.078 10.1773 11.7 10.6395 11.7H13.1605C13.6227 11.7 14 12.078 14 12.5401V13.6599C14 14.122 13.6227 14.5 13.1605 14.5H10.6395C10.1773 14.5 9.8 14.122 9.8 13.6599V13.625H8.75C7.68633 13.625 6.825 12.7637 6.825 11.7V3.125H4.9V3.3C4.9 4.06973 4.26973 4.7 3.5 4.7Z"
        fill="#536787"
      />
    </svg>
  );
}

export function RightArrowIcon({ stroke = "#D2D9E5" }) {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 11L6 6L1 1" stroke={stroke} strokeWidth="1.5" />
    </svg>
  );
}

export function NewChatMessageIcon() {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0H0.833348C0.612335 0 0.400373 0.0877973 0.244093 0.244078C0.0878124 0.400358 1.50908e-05 0.61232 1.50908e-05 0.833333V9.16667C-0.000945887 9.32558 0.0440081 9.48138 0.129473 9.61535C0.214939 9.74933 0.337278 9.85576 0.481786 9.92188C0.591905 9.97315 0.711876 9.99981 0.833348 10C1.02898 9.99953 1.21811 9.92978 1.3672 9.80312C1.36969 9.8015 1.37196 9.79958 1.37397 9.7974L3.04689 8.33333H10C10.221 8.33333 10.433 8.24554 10.5893 8.08926C10.7456 7.93297 10.8333 7.72101 10.8333 7.5V0.833333C10.8333 0.61232 10.7456 0.400358 10.5893 0.244078C10.433 0.0877973 10.221 0 10 0Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8906 15.8793L16.8906 15.8793L13.1073 12.0968C14.2002 10.7488 14.7431 9.03596 14.6248 7.30238C14.5043 5.53839 13.7084 3.88874 12.4027 2.6966C11.097 1.50445 9.38189 0.861603 7.61425 0.901775C5.84662 0.941948 4.16251 1.66205 2.91228 2.91228C1.66205 4.16251 0.941948 5.84662 0.901775 7.61425C0.861603 9.38189 1.50445 11.097 2.6966 12.4027C3.88874 13.7084 5.53839 14.5043 7.30238 14.6248C9.03596 14.7431 10.7488 14.2002 12.0968 13.1073L15.8793 16.8906L15.8793 16.8906C15.9457 16.957 16.0245 17.0096 16.1113 17.0456C16.1981 17.0815 16.291 17.1 16.3849 17.1C16.4788 17.1 16.5718 17.0815 16.6586 17.0456C16.7453 17.0096 16.8242 16.957 16.8906 16.8906C16.957 16.8242 17.0096 16.7453 17.0456 16.6586C17.0815 16.5718 17.1 16.4788 17.1 16.3849C17.1 16.291 17.0815 16.1981 17.0456 16.1113C17.0096 16.0245 16.957 15.9457 16.8906 15.8793ZM2.34642 7.77888C2.34642 6.70444 2.66503 5.65413 3.26196 4.76077C3.85888 3.8674 4.70732 3.17111 5.69997 2.75994C6.69262 2.34877 7.78491 2.24119 8.83871 2.4508C9.8925 2.66042 10.8605 3.17781 11.6202 3.93755C12.38 4.6973 12.8974 5.66527 13.107 6.71906C13.3166 7.77286 13.209 8.86514 12.7978 9.8578C12.3867 10.8505 11.6904 11.6989 10.797 12.2958C9.90367 12.8927 8.8534 13.2113 7.779 13.2113C6.33868 13.2098 4.95781 12.6369 3.93935 11.6184C2.92092 10.6 2.34805 9.21916 2.34642 7.77888Z"
        fill="#536787"
        stroke="#536787"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function LeftArrow() {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.5 1L1.5 6L6.5 11" stroke="#7A3DAA" strokeWidth="1.5" />
    </svg>
  );
}

export function SampleQuestionIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0938 10.4465C13.6889 9.39458 14.0016 8.20645 14.0013 6.9978C14.0009 5.93438 13.7582 4.88504 13.2917 3.92942C12.8251 2.9738 12.147 2.13702 11.3088 1.4826C10.4706 0.828177 9.49434 0.373314 8.45409 0.152536C7.41384 -0.0682428 6.33697 -0.0491343 5.30521 0.208411C4.27345 0.465956 3.31392 0.955169 2.49945 1.63892C1.68499 2.32266 1.037 3.18297 0.604662 4.15454C0.172328 5.12611 -0.0329855 6.1834 0.00430631 7.24617C0.0415982 8.30894 0.320515 9.34924 0.819886 10.2881L0.0558705 12.5802C-0.00741511 12.7699 -0.0165993 12.9736 0.0293473 13.1683C0.0752939 13.363 0.174556 13.541 0.316007 13.6825C0.457458 13.8239 0.635509 13.9232 0.830203 13.9691C1.0249 14.0151 1.22854 14.0059 1.41831 13.9426L3.71036 13.1786C4.77719 13.7466 5.97292 14.0288 7.18117 13.9977C8.38941 13.9665 9.56901 13.6231 10.6051 13.0008C11.6413 12.3785 12.4986 11.4985 13.0938 10.4465ZM9.53678 6.30157C9.63777 6.20058 9.69451 6.06361 9.69451 5.92079C9.69451 5.77797 9.63777 5.64099 9.53678 5.54C9.43579 5.43901 9.29882 5.38227 9.15599 5.38227H4.84789C4.70507 5.38227 4.56809 5.43901 4.4671 5.54C4.36611 5.64099 4.30937 5.77797 4.30937 5.92079C4.30937 6.06361 4.36611 6.20058 4.4671 6.30157C4.56809 6.40256 4.70507 6.4593 4.84789 6.4593H9.15599C9.29882 6.4593 9.43579 6.40256 9.53678 6.30157ZM4.84789 7.53633H9.15599C9.29882 7.53633 9.43579 7.59306 9.53678 7.69405C9.63777 7.79504 9.69451 7.93202 9.69451 8.07484C9.69451 8.21766 9.63777 8.35464 9.53678 8.45563C9.43579 8.55662 9.29882 8.61335 9.15599 8.61335H4.84789C4.70507 8.61335 4.56809 8.55662 4.4671 8.45563C4.36611 8.35464 4.30937 8.21766 4.30937 8.07484C4.30937 7.93202 4.36611 7.79504 4.4671 7.69405C4.56809 7.59306 4.70507 7.53633 4.84789 7.53633Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function ChatUploadIcon() {
  return (
    <svg
      width="12"
      height="21"
      viewBox="0 0 12 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.303 4.16037L10.297 14.2626C10.3023 16.8947 8.40458 18.5315 6.13672 18.5191C3.8757 18.5273 1.99369 16.9065 1.98838 14.2745L2.00107 4.47634C2.00197 2.89574 3.0542 1.62374 4.55923 1.61599C6.07116 1.6288 7.11503 2.89265 7.12095 4.46641L7.11532 13.9553C7.12863 14.6425 6.61301 14.952 6.14571 14.9524C5.67153 14.9458 5.1769 14.6437 5.16353 13.9564L5.18289 4.55512C5.1763 4.13589 4.88782 3.81996 4.48923 3.82019C4.09751 3.8273 3.80868 4.1436 3.80841 4.55596L3.8028 13.9985C3.80196 15.4004 4.90096 16.4444 6.13797 16.4437C7.48491 16.4428 8.48891 15.4114 8.48971 13.9957L8.4954 4.45187C8.49695 1.88161 6.7523 0.24709 4.51194 0.248429C2.32657 0.249701 0.525056 1.88637 0.523509 4.45664L0.52454 14.3372C0.522514 17.7321 3.07767 20.0259 6.14269 20.0241C9.20088 20.0154 11.7587 17.7185 11.7676 14.3305L11.7736 4.1595C11.7739 3.76091 11.4098 3.39688 11.0182 3.41773C10.6058 3.40418 10.3101 3.75488 10.303 4.16037Z"
        fill="#536787"
      />
    </svg>
  );
}

export function SampleQuestionOutlineIcon() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6912 7.61242C12.6912 7.79605 12.6183 7.97216 12.4885 8.10201C12.3586 8.23185 12.1825 8.3048 11.9989 8.3048H6.45988C6.27625 8.3048 6.10014 8.23185 5.9703 8.10201C5.84045 7.97216 5.76751 7.79605 5.76751 7.61242C5.76751 7.42879 5.84045 7.25269 5.9703 7.12284C6.10014 6.993 6.27625 6.92005 6.45988 6.92005H11.9989C12.1825 6.92005 12.3586 6.993 12.4885 7.12284C12.6183 7.25269 12.6912 7.42879 12.6912 7.61242ZM11.9989 9.68954H6.45988C6.27625 9.68954 6.10014 9.76249 5.9703 9.89234C5.84045 10.0222 5.76751 10.1983 5.76751 10.3819C5.76751 10.5655 5.84045 10.7417 5.9703 10.8715C6.10014 11.0013 6.27625 11.0743 6.45988 11.0743H11.9989C12.1825 11.0743 12.3586 11.0013 12.4885 10.8715C12.6183 10.7417 12.6912 10.5655 12.6912 10.3819C12.6912 10.1983 12.6183 10.0222 12.4885 9.89234C12.3586 9.76249 12.1825 9.68954 11.9989 9.68954ZM18.2302 8.99717C18.2306 10.5511 17.8286 12.0787 17.0634 13.4313C16.2982 14.7838 15.1959 15.9152 13.8637 16.7153C12.5315 17.5154 11.0149 17.9569 9.46144 17.997C7.90798 18.0371 6.37061 17.6743 4.99897 16.9439L2.05206 17.9262C1.80807 18.0076 1.54624 18.0194 1.29592 17.9603C1.0456 17.9012 0.816676 17.7736 0.63481 17.5917C0.452944 17.4099 0.325322 17.181 0.266248 16.9306C0.207174 16.6803 0.218982 16.4185 0.300349 16.1745L1.28265 13.2276C0.640607 12.0204 0.281999 10.6829 0.234052 9.3165C0.186106 7.95009 0.45008 6.59071 1.00594 5.34155C1.5618 4.09239 2.39493 2.98628 3.4421 2.10718C4.48927 1.22807 5.72295 0.599086 7.0495 0.267957C8.37605 -0.0631727 9.7606 -0.0877407 11.0981 0.196117C12.4355 0.479975 13.6907 1.0648 14.7684 1.9062C15.8461 2.74759 16.718 3.82345 17.3178 5.05211C17.9176 6.28076 18.2297 7.62992 18.2302 8.99717ZM16.8455 8.99717C16.8452 7.8289 16.5761 6.67636 16.059 5.62872C15.542 4.58109 14.7909 3.66644 13.8638 2.95554C12.9367 2.24465 11.8585 1.75656 10.7126 1.52904C9.56669 1.30152 8.3838 1.34067 7.25545 1.64346C6.12709 1.94625 5.08352 2.50457 4.20547 3.27521C3.32742 4.04585 2.63843 5.00817 2.19179 6.0877C1.74516 7.16723 1.55287 8.33504 1.62979 9.50078C1.70671 10.6665 2.05078 11.7989 2.63538 12.8104C2.68445 12.8953 2.71491 12.9897 2.72476 13.0873C2.73461 13.1849 2.72361 13.2834 2.6925 13.3764L1.61326 16.6133L4.85011 15.534C4.92061 15.51 4.99459 15.4977 5.06908 15.4977C5.19068 15.4979 5.31008 15.5302 5.41526 15.5912C6.57308 16.2611 7.88692 16.6142 9.22457 16.615C10.5622 16.6159 11.8765 16.2644 13.0352 15.596C14.1938 14.9276 15.156 13.9658 15.8249 12.8074C16.4938 11.649 16.8458 10.3348 16.8455 8.99717Z"
        fill="#536787"
      />
    </svg>
  );
}

export function ChatMicIcon() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.10977 13.15C10.0988 13.15 11.7098 11.539 11.7098 9.55V4.6C11.7098 2.611 10.0988 1 8.10977 1C6.12077 1 4.50977 2.611 4.50977 4.6V9.55C4.50977 11.539 6.12077 13.15 8.10977 13.15Z"
        stroke="#536787"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.22852 7.88672V9.41672C1.22852 13.2147 4.31552 16.3017 8.11352 16.3017C11.9115 16.3017 14.9985 13.2147 14.9985 9.41672V7.88672"
        stroke="#536787"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.11133 16.3008V19.0008"
        stroke="#536787"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* export function ChatHistoryOpenIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="#F7F8FA"
      />
      <path d="M9 19L14 14L9 9" stroke="#536787" strokeWidth="1.5" />
      <path d="M14 19L19 14L14 9" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryCloseIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_2646_20007" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_2646_20007)"
      />
      <path d="M14 9L9 14L14 19" stroke="#536787" strokeWidth="1.5" />
      <path d="M19 9L14 14L19 19" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
} */

export function ChatHistoryOpenIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_5003_29727" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_5003_29727)"
      />
      <path d="M9 19L14 14L9 9" stroke="#536787" strokeWidth="1.5" />
      <path d="M14 19L19 14L14 9" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryCloseIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_5028_2782" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_5028_2782)"
      />
      <path d="M14 9L9 14L14 19" stroke="#536787" strokeWidth="1.5" />
      <path d="M19 9L14 14L19 19" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryIcon() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.850015 10.1662C0.848971 10.3539 0.902094 10.5378 1.00301 10.696C1.10393 10.8542 1.24834 10.9799 1.41893 11.0581C1.54868 11.1184 1.69001 11.1498 1.83311 11.15L1.83371 11.15C2.06276 11.1495 2.28428 11.0685 2.45966 10.9214C2.46554 10.9169 2.47114 10.9121 2.47645 10.907L4.10326 9.48333H11C11.2608 9.48333 11.5109 9.37973 11.6953 9.19532C11.8797 9.01091 11.9833 8.7608 11.9833 8.5V1.83333C11.9833 1.57254 11.8797 1.32242 11.6953 1.13801C11.5109 0.953601 11.2608 0.85 11 0.85H1.83335C1.57255 0.85 1.32244 0.953601 1.13803 1.13801C0.953616 1.32242 0.850015 1.57254 0.850015 1.83333V10.1662ZM0.850015 10.1662C0.850016 10.1661 0.850017 10.1659 0.850018 10.1658L1.00002 10.1667H0.850015V10.1662ZM3.41394 8.58047L3.41385 8.58036L3.40907 8.58474L3.40403 8.58936L1.98335 9.83556V1.98333H10.85V8.35H4.04696C4.04694 8.35 4.04691 8.35 4.04689 8.35C3.81535 8.34991 3.59121 8.43152 3.41394 8.58047Z"
        fill="black"
        stroke="black"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function ChatHistoryOutlinedIcon({ fill = "#7A3DAA" }) {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0H0.833348C0.612335 0 0.400373 0.0877973 0.244093 0.244078C0.0878124 0.400358 1.50908e-05 0.61232 1.50908e-05 0.833333V9.16667C-0.000945887 9.32558 0.0440081 9.48138 0.129473 9.61535C0.214939 9.74933 0.337278 9.85576 0.481786 9.92188C0.591905 9.97315 0.711876 9.99981 0.833348 10C1.02898 9.99953 1.21811 9.92978 1.3672 9.80312C1.36969 9.8015 1.37196 9.79958 1.37397 9.7974L3.04689 8.33333H10C10.221 8.33333 10.433 8.24554 10.5893 8.08926C10.7456 7.93297 10.8333 7.72101 10.8333 7.5V0.833333C10.8333 0.61232 10.7456 0.400358 10.5893 0.244078C10.433 0.0877973 10.221 0 10 0Z"
        fill={fill}
      />
    </svg>
  );
}

export function PlusIcon({ className }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0V5M5 10V5M5 5H10M5 5H0"
        className={classNames(className)}
        strokeWidth="2"
      />
    </svg>
  );
}

export function ChatQuestionSubmitIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4908 7.90513L2.36581 0.413719C2.14457 0.289613 1.89081 0.235757 1.63823 0.259304C1.38566 0.282852 1.14622 0.382688 0.951738 0.545551C0.757252 0.708414 0.61692 0.926595 0.549383 1.17111C0.481846 1.41563 0.490302 1.6749 0.573626 1.9145L2.9955 8.98247C2.99519 8.98506 2.99519 8.98769 2.9955 8.99028C2.99506 8.99287 2.99506 8.99551 2.9955 8.99809L0.573626 16.0817C0.506897 16.2702 0.486352 16.4719 0.513716 16.67C0.54108 16.868 0.615555 17.0566 0.730889 17.2199C0.846224 17.3833 0.999053 17.5165 1.17655 17.6086C1.35405 17.7006 1.55103 17.7487 1.75097 17.7489C1.9679 17.7483 2.18102 17.6918 2.36972 17.5848L15.4877 10.0809C15.6812 9.97251 15.8424 9.81459 15.9547 9.62333C16.067 9.43208 16.1264 9.21439 16.1268 8.9926C16.1272 8.7708 16.0686 8.5529 15.9569 8.36125C15.8453 8.16959 15.6847 8.01109 15.4916 7.902L15.4908 7.90513ZM1.75097 16.4989V16.4918L4.10566 9.62387H8.62597C8.79173 9.62387 8.9507 9.55803 9.06791 9.44082C9.18512 9.32361 9.25097 9.16464 9.25097 8.99887C9.25097 8.83311 9.18512 8.67414 9.06791 8.55693C8.9507 8.43972 8.79173 8.37387 8.62597 8.37387H4.11191L1.75566 1.50825L1.75097 1.49887L14.876 8.98559L1.75097 16.4989Z"
        fill="#536787"
      />
    </svg>
  );
}

export function ChatResponseLikeIcon() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7969 4.38156C12.6737 4.24196 12.5222 4.13016 12.3525 4.0536C12.1828 3.97704 11.9987 3.93746 11.8125 3.9375H8.75V3.0625C8.75 2.48234 8.51953 1.92594 8.1093 1.5157C7.69906 1.10547 7.14266 0.875 6.5625 0.875C6.48122 0.874942 6.40153 0.897526 6.33237 0.940221C6.26321 0.982916 6.20731 1.04403 6.17094 1.11672L4.10484 5.25H1.75C1.51794 5.25 1.29538 5.34219 1.13128 5.50628C0.967187 5.67038 0.875 5.89294 0.875 6.125V10.9375C0.875 11.1696 0.967187 11.3921 1.13128 11.5562C1.29538 11.7203 1.51794 11.8125 1.75 11.8125H11.1562C11.476 11.8126 11.7848 11.696 12.0247 11.4845C12.2645 11.2731 12.4189 10.9813 12.4589 10.6641L13.1152 5.41406C13.1384 5.22923 13.1221 5.04157 13.0672 4.86354C13.0123 4.68552 12.9202 4.52122 12.7969 4.38156ZM1.75 6.125H3.9375V10.9375H1.75V6.125ZM12.2467 5.30469L11.5905 10.5547C11.5771 10.6604 11.5257 10.7577 11.4457 10.8282C11.3658 10.8987 11.2628 10.9375 11.1562 10.9375H4.8125V5.79086L6.82008 1.77516C7.11763 1.83471 7.38535 1.99552 7.57768 2.23023C7.77002 2.46495 7.87508 2.75905 7.875 3.0625V4.375C7.875 4.49103 7.92109 4.60231 8.00314 4.68436C8.08519 4.76641 8.19647 4.8125 8.3125 4.8125H11.8125C11.8746 4.81248 11.936 4.82567 11.9926 4.8512C12.0491 4.87673 12.0997 4.91401 12.1407 4.96056C12.1818 5.00712 12.2125 5.06188 12.2308 5.12122C12.249 5.18055 12.2545 5.24309 12.2467 5.30469Z"
        fill="black"
      />
    </svg>
  );
}

export function ChatResponseDislikeIcon() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.20313 7.61844C1.32632 7.75804 1.47781 7.86984 1.64753 7.9464C1.81724 8.02296 2.00131 8.06254 2.1875 8.0625L5.25 8.0625L5.25 8.9375C5.25 9.51766 5.48047 10.0741 5.8907 10.4843C6.30094 10.8945 6.85734 11.125 7.4375 11.125C7.51878 11.1251 7.59847 11.1025 7.66763 11.0598C7.73679 11.0171 7.79269 10.956 7.82906 10.8833L9.89516 6.75L12.25 6.75C12.4821 6.75 12.7046 6.65781 12.8687 6.49372C13.0328 6.32962 13.125 6.10706 13.125 5.875L13.125 1.0625C13.125 0.830436 13.0328 0.607876 12.8687 0.443782C12.7046 0.279688 12.4821 0.1875 12.25 0.1875L2.84375 0.187499C2.52399 0.187389 2.21519 0.304014 1.97533 0.515474C1.73548 0.726935 1.58106 1.01868 1.54109 1.33594L0.884844 6.58594C0.861584 6.77077 0.877937 6.95843 0.932815 7.13646C0.987692 7.31448 1.07984 7.47878 1.20313 7.61844ZM12.25 5.875L10.0625 5.875L10.0625 1.0625L12.25 1.0625L12.25 5.875ZM1.75328 6.69531L2.40953 1.44531C2.42286 1.33956 2.47433 1.24231 2.55428 1.17182C2.63423 1.10134 2.73716 1.06246 2.84375 1.0625L9.1875 1.0625L9.1875 6.20914L7.17992 10.2248C6.88237 10.1653 6.61465 10.0045 6.42232 9.76977C6.22998 9.53505 6.12492 9.24095 6.125 8.9375L6.125 7.625C6.125 7.50897 6.07891 7.39769 5.99686 7.31564C5.91481 7.23359 5.80353 7.1875 5.6875 7.1875L2.1875 7.1875C2.12542 7.18752 2.06404 7.17433 2.00745 7.1488C1.95086 7.12327 1.90035 7.08599 1.85928 7.03943C1.8182 6.99288 1.78751 6.93812 1.76923 6.87878C1.75096 6.81945 1.74552 6.75691 1.75328 6.69531Z"
        fill="black"
      />
    </svg>
  );
}

export function ChatResponseSoundIcon() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.39044 0.0544124C9.29989 0.0102873 9.19877 -0.00755341 9.09859 0.00291732C8.9984 0.0133881 8.90316 0.0517505 8.82369 0.113645L4.12275 3.76926H1.07696C0.791334 3.76926 0.517405 3.88273 0.315435 4.08469C0.113465 4.28666 0 4.56059 0 4.84622V9.15407C0 9.4397 0.113465 9.71363 0.315435 9.9156C0.517405 10.1176 0.791334 10.231 1.07696 10.231H4.12275L8.82369 13.8866C8.90324 13.9485 8.99854 13.9868 9.09877 13.9971C9.19899 14.0075 9.30012 13.9895 9.39064 13.9453C9.48117 13.9011 9.55746 13.8323 9.61085 13.7469C9.66424 13.6614 9.69259 13.5627 9.69266 13.4619V0.538372C9.69268 0.437493 9.66435 0.338639 9.61092 0.253073C9.55749 0.167508 9.48109 0.0986731 9.39044 0.0544124ZM1.07696 4.84622H3.76937V9.15407H1.07696V4.84622ZM8.6157 12.3607L4.84633 9.42937V4.57092L8.6157 1.63957V12.3607ZM12.2504 5.22047C12.6836 5.71215 12.9225 6.3449 12.9225 7.00015C12.9225 7.65539 12.6836 8.28814 12.2504 8.77983C12.1553 8.88436 12.0229 8.9473 11.8818 8.95506C11.7406 8.96282 11.6021 8.91478 11.4961 8.8213C11.3901 8.72783 11.325 8.59641 11.3151 8.45542C11.3051 8.31443 11.3509 8.17517 11.4427 8.06769C11.7024 7.77271 11.8457 7.39317 11.8457 7.00015C11.8457 6.60713 11.7024 6.22758 11.4427 5.93261C11.3509 5.82513 11.3051 5.68586 11.3151 5.54487C11.325 5.40388 11.3901 5.27247 11.4961 5.17899C11.6021 5.08552 11.7406 5.03748 11.8818 5.04523C12.0229 5.05299 12.1553 5.11593 12.2504 5.22047ZM15.616 7.00015C15.6167 8.32495 15.1285 9.60342 14.2448 10.5905C14.1489 10.6943 14.016 10.7562 13.8749 10.7629C13.7337 10.7696 13.5955 10.7205 13.4902 10.6262C13.3849 10.5319 13.3209 10.4001 13.312 10.259C13.3031 10.118 13.3499 9.97906 13.4425 9.87227C14.1489 9.08248 14.5394 8.06007 14.5394 7.00048C14.5394 5.9409 14.1489 4.91849 13.4425 4.1287C13.394 4.07623 13.3565 4.01465 13.332 3.94753C13.3076 3.88041 13.2967 3.8091 13.3001 3.73774C13.3035 3.66639 13.321 3.59642 13.3517 3.53191C13.3824 3.4674 13.4256 3.40964 13.4788 3.362C13.5321 3.31435 13.5942 3.27778 13.6617 3.2544C13.7292 3.23102 13.8007 3.2213 13.872 3.22581C13.9433 3.23033 14.013 3.24898 14.077 3.28069C14.141 3.31239 14.1981 3.35652 14.2448 3.4105C15.1287 4.39714 15.617 5.6755 15.616 7.00015Z"
        fill="black"
      />
    </svg>
  );
}

export function ChatResponseCopyIcon() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6986 2.33333H1.19857C1.04386 2.33333 0.895485 2.39479 0.786089 2.50419C0.676693 2.61358 0.615234 2.76196 0.615234 2.91667V13.4167C0.615234 13.5714 0.676693 13.7197 0.786089 13.8291C0.895485 13.9385 1.04386 14 1.19857 14H11.6986C11.8533 14 12.0017 13.9385 12.111 13.8291C12.2204 13.7197 12.2819 13.5714 12.2819 13.4167V2.91667C12.2819 2.76196 12.2204 2.61358 12.111 2.50419C12.0017 2.39479 11.8533 2.33333 11.6986 2.33333ZM11.1152 12.8333H1.7819V3.5H11.1152V12.8333ZM14.6152 0.583333V11.0833C14.6152 11.238 14.5538 11.3864 14.4444 11.4958C14.335 11.6052 14.1866 11.6667 14.0319 11.6667C13.8772 11.6667 13.7288 11.6052 13.6194 11.4958C13.51 11.3864 13.4486 11.238 13.4486 11.0833V1.16667H3.5319C3.37719 1.16667 3.22882 1.10521 3.11942 0.995812C3.01003 0.886416 2.94857 0.738043 2.94857 0.583333C2.94857 0.428624 3.01003 0.280251 3.11942 0.170854C3.22882 0.0614583 3.37719 0 3.5319 0H14.0319C14.1866 0 14.335 0.0614583 14.4444 0.170854C14.5538 0.280251 14.6152 0.428624 14.6152 0.583333Z"
        fill="black"
      />
    </svg>
  );
}

export function ChatResponseShareIcon() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.116 9.00071C9.78249 9.00061 9.45236 9.06742 9.14515 9.19719C8.83795 9.32697 8.5599 9.51707 8.32749 9.75623L5.44665 7.90462C5.67326 7.32352 5.67326 6.67848 5.44665 6.09738L8.32749 4.24577C8.76021 4.68903 9.3421 4.95583 9.96036 4.99443C10.5786 5.03303 11.1892 4.8407 11.6737 4.45471C12.1582 4.06872 12.4821 3.51658 12.5826 2.90533C12.6832 2.29408 12.5532 1.66728 12.2178 1.14644C11.8825 0.625609 11.3657 0.247846 10.7676 0.0863951C10.1696 -0.0750554 9.53288 -0.00869081 8.98098 0.272622C8.42908 0.553935 8.0013 1.03015 7.78057 1.60895C7.55983 2.18775 7.56188 2.82789 7.78631 3.40526L4.90547 5.25688C4.55857 4.90072 4.11333 4.65611 3.62668 4.55432C3.14003 4.45252 2.63408 4.49815 2.17351 4.68539C1.71293 4.87263 1.31865 5.19297 1.04108 5.60545C0.763499 6.01793 0.615234 6.50382 0.615234 7.001C0.615234 7.49818 0.763499 7.98407 1.04108 8.39655C1.31865 8.80903 1.71293 9.12937 2.17351 9.31661C2.63408 9.50385 3.14003 9.54948 3.62668 9.44769C4.11333 9.34589 4.55857 9.10128 4.90547 8.74513L7.78631 10.5967C7.59332 11.0945 7.56476 11.641 7.70482 12.1561C7.84488 12.6713 8.14619 13.1281 8.56464 13.4596C8.98309 13.7911 9.49669 13.98 10.0302 13.9985C10.5638 14.017 11.0892 13.8642 11.5296 13.5625C11.9701 13.2608 12.3023 12.826 12.4777 12.3217C12.6532 11.8175 12.6626 11.2704 12.5045 10.7604C12.3465 10.2505 12.0294 9.80456 11.5996 9.4879C11.1697 9.17125 10.6498 9.00051 10.116 9.00071ZM10.116 1.00186C10.4126 1.00186 10.7026 1.08982 10.9492 1.25462C11.1959 1.41942 11.3881 1.65365 11.5016 1.9277C11.6151 2.20175 11.6448 2.50331 11.5869 2.79424C11.5291 3.08517 11.3862 3.3524 11.1765 3.56215C10.9667 3.7719 10.6995 3.91474 10.4086 3.97261C10.1176 4.03048 9.81609 4.00078 9.54204 3.88727C9.26799 3.77375 9.03375 3.58152 8.86895 3.33488C8.70415 3.08824 8.61619 2.79827 8.61619 2.50164C8.61619 2.10388 8.77421 1.7224 9.05547 1.44114C9.33674 1.15987 9.71821 1.00186 10.116 1.00186ZM3.11698 8.50079C2.82035 8.50079 2.53038 8.41282 2.28374 8.24803C2.03711 8.08323 1.84487 7.84899 1.73136 7.57494C1.61784 7.30089 1.58814 6.99934 1.64601 6.70841C1.70388 6.41748 1.84672 6.15024 2.05647 5.94049C2.26622 5.73074 2.53346 5.5879 2.82439 5.53003C3.11532 5.47216 3.41687 5.50186 3.69092 5.61538C3.96497 5.72889 4.19921 5.92113 4.36401 6.16776C4.5288 6.4144 4.61677 6.70437 4.61677 7.001C4.61677 7.39877 4.45875 7.78024 4.17749 8.06151C3.89622 8.34277 3.51475 8.50079 3.11698 8.50079ZM10.116 13.0001C9.81935 13.0001 9.52938 12.9122 9.28274 12.7474C9.03611 12.5826 8.84387 12.3483 8.73036 12.0743C8.61684 11.8002 8.58714 11.4987 8.64501 11.2078C8.70288 10.9168 8.84572 10.6496 9.05547 10.4398C9.26522 10.2301 9.53246 10.0873 9.82339 10.0294C10.1143 9.97152 10.4159 10.0012 10.6899 10.1147C10.964 10.2283 11.1982 10.4205 11.363 10.6671C11.5278 10.9138 11.6158 11.2037 11.6158 11.5004C11.6158 11.8981 11.4578 12.2796 11.1765 12.5609C10.8952 12.8421 10.5137 13.0001 10.116 13.0001Z"
        fill="black"
      />
    </svg>
  );
}

export function ChatResponseRefreshIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66523 3.15662C5.27454 2.97453 5.94688 2.85547 6.68925 2.85547C10.0439 2.85547 12.7613 5.57284 12.7613 8.92753C12.7613 12.2822 10.0439 14.9996 6.68925 14.9996C3.33456 14.9996 0.617188 12.2822 0.617188 8.92753C0.617188 7.68091 0.995378 6.51832 1.6397 5.55183"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.80273 3.32517L5.82676 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.80273 3.32422L6.16293 5.04709"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PersonSkeletonIcon({ className }) {
  return (
    <svg
      width="61"
      height="64"
      viewBox="0 0 61 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M47.2893 16.8421C47.2893 26.1437 39.7781 33.6842 30.5126 33.6842C21.2471 33.6842 13.7359 26.1437 13.7359 16.8421C13.7359 7.54047 21.2471 0 30.5126 0C39.7781 0 47.2893 7.54047 47.2893 16.8421Z"
        className={classNames("fill-[#D8DEE7]", className)}
      />
      <path
        d="M0 62.3158C0 48.3705 13.6898 37.0526 30.5 37.0526C47.3102 37.0526 61 48.3705 61 62.3158C61 63.2589 60.2618 64 59.3223 64H1.67767C0.738174 64 0 63.2589 0 62.3158Z"
        className={classNames("fill-[#D8DEE7]", className)}
      />
    </svg>
  );
}

export function SuggestedPersonaEditArrowIcon() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.997389 1.2487C0.997389 1.61536 1.29739 1.91536 1.66406 1.91536H6.72406L0.804056 7.83536C0.742334 7.89708 0.693374 7.97036 0.659971 8.051C0.626568 8.13164 0.609375 8.21808 0.609375 8.30536C0.609375 8.39265 0.626568 8.47908 0.659971 8.55973C0.693374 8.64037 0.742334 8.71364 0.804056 8.77536C0.865777 8.83709 0.939051 8.88605 1.01969 8.91945C1.10034 8.95285 1.18677 8.97004 1.27406 8.97004C1.36134 8.97004 1.44777 8.95285 1.52842 8.91945C1.60906 8.88605 1.68233 8.83709 1.74406 8.77536L7.66406 2.85536V7.91536C7.66406 8.28203 7.96406 8.58203 8.33072 8.58203C8.69739 8.58203 8.99739 8.28203 8.99739 7.91536V1.2487C8.99739 0.882031 8.69739 0.582031 8.33072 0.582031H1.66406C1.29739 0.582031 0.997389 0.882031 0.997389 1.2487Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function UpdatePersonaBackIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.46811 14.8057C8.81678 14.457 8.81678 13.8864 8.46811 13.5377L3.65637 8.726L14.9155 8.726C15.0328 8.726 15.1491 8.70288 15.2575 8.65796C15.366 8.61304 15.4645 8.5472 15.5475 8.46419C15.6305 8.38119 15.6964 8.28265 15.7413 8.1742C15.7862 8.06575 15.8093 7.94951 15.8093 7.83212C15.8093 7.71474 15.7862 7.5985 15.7413 7.49005C15.6964 7.3816 15.6305 7.28306 15.5475 7.20006C15.4645 7.11705 15.366 7.05121 15.2575 7.00629C15.1491 6.96136 15.0328 6.93824 14.9155 6.93824L3.65637 6.93824L8.46811 2.1265C8.81678 1.77783 8.81678 1.20726 8.46811 0.858588C8.11943 0.509911 7.54887 0.509911 7.20019 0.858588L0.860612 7.19817C0.511936 7.54684 0.511936 8.1174 0.860613 8.46608L7.20019 14.8057C7.54887 15.1543 8.11943 15.1543 8.46811 14.8057Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function UpdatePersonaDeleteIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5527 3.14453H12.2715V2.48828C12.2715 1.96614 12.0641 1.46538 11.6949 1.09616C11.3256 0.726953 10.8249 0.519531 10.3027 0.519531H6.36523C5.84309 0.519531 5.34233 0.726953 4.97312 1.09616C4.60391 1.46538 4.39648 1.96614 4.39648 2.48828V3.14453H1.11523C0.941186 3.14453 0.774266 3.21367 0.651196 3.33674C0.528125 3.45981 0.458984 3.62673 0.458984 3.80078C0.458984 3.97483 0.528125 4.14175 0.651196 4.26482C0.774266 4.38789 0.941186 4.45703 1.11523 4.45703H1.77148V16.2695C1.77148 16.6176 1.90977 16.9515 2.15591 17.1976C2.40205 17.4438 2.73589 17.582 3.08398 17.582H13.584C13.9321 17.582 14.2659 17.4438 14.5121 17.1976C14.7582 16.9515 14.8965 16.6176 14.8965 16.2695V4.45703H15.5527C15.7268 4.45703 15.8937 4.38789 16.0168 4.26482C16.1398 4.14175 16.209 3.97483 16.209 3.80078C16.209 3.62673 16.1398 3.45981 16.0168 3.33674C15.8937 3.21367 15.7268 3.14453 15.5527 3.14453ZM5.70898 2.48828C5.70898 2.31423 5.77812 2.14731 5.9012 2.02424C6.02427 1.90117 6.19119 1.83203 6.36523 1.83203H10.3027C10.4768 1.83203 10.6437 1.90117 10.7668 2.02424C10.8898 2.14731 10.959 2.31423 10.959 2.48828V3.14453H5.70898V2.48828ZM13.584 16.2695H3.08398V4.45703H13.584V16.2695ZM7.02148 7.73828V12.9883C7.02148 13.1623 6.95234 13.3292 6.82927 13.4523C6.7062 13.5754 6.53928 13.6445 6.36523 13.6445C6.19119 13.6445 6.02427 13.5754 5.9012 13.4523C5.77812 13.3292 5.70898 13.1623 5.70898 12.9883V7.73828C5.70898 7.56423 5.77812 7.39731 5.9012 7.27424C6.02427 7.15117 6.19119 7.08203 6.36523 7.08203C6.53928 7.08203 6.7062 7.15117 6.82927 7.27424C6.95234 7.39731 7.02148 7.56423 7.02148 7.73828ZM10.959 7.73828V12.9883C10.959 13.1623 10.8898 13.3292 10.7668 13.4523C10.6437 13.5754 10.4768 13.6445 10.3027 13.6445C10.1287 13.6445 9.96177 13.5754 9.8387 13.4523C9.71562 13.3292 9.64648 13.1623 9.64648 12.9883V7.73828C9.64648 7.56423 9.71562 7.39731 9.8387 7.27424C9.96177 7.15117 10.1287 7.08203 10.3027 7.08203C10.4768 7.08203 10.6437 7.15117 10.7668 7.27424C10.8898 7.39731 10.959 7.56423 10.959 7.73828Z"
        fill="#7A3DAA"
      />
    </svg>
  );
}

export function UpdatePersonaPensilIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.38672 5.17578H2.52214C2.06353 5.17578 1.62371 5.35796 1.29943 5.68224C0.975148 6.00652 0.792969 6.44634 0.792969 6.90495V14.6862C0.792969 15.1448 0.975148 15.5846 1.29943 15.9089C1.62371 16.2332 2.06353 16.4154 2.52214 16.4154H10.3034C10.762 16.4154 11.2018 16.2332 11.5261 15.9089C11.8504 15.5846 12.0326 15.1448 12.0326 14.6862V13.8216"
        stroke="#7A3DAA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1654 3.44801L13.7591 6.04176M14.9566 4.81837C15.2971 4.47786 15.4884 4.01603 15.4884 3.53447C15.4884 3.05291 15.2971 2.59107 14.9566 2.25056C14.6161 1.91005 14.1542 1.71875 13.6727 1.71875C13.1911 1.71875 12.7293 1.91005 12.3888 2.25056L5.11328 9.50009V12.0938H7.70703L14.9566 4.81837Z"
        stroke="#7A3DAA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CreateChatIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block group-hover/icons:hidden"
    >
      <mask id="path-1-inside-1_5003_29919" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_5003_29919)"
      />
      <path
        d="M14 8H9.33333C8.97971 8 8.64057 8.14048 8.39052 8.39052C8.14048 8.64057 8 8.97971 8 9.33333V18.6667C8 19.0203 8.14048 19.3594 8.39052 19.6095C8.64057 19.8595 8.97971 20 9.33333 20H18.6667C19.0203 20 19.3594 19.8595 19.6095 19.6095C19.8595 19.3594 20 19.0203 20 18.6667V14"
        stroke="#536787"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2487 7.75015C18.5139 7.48493 18.8736 7.33594 19.2487 7.33594C19.6238 7.33594 19.9835 7.48493 20.2487 7.75015C20.5139 8.01537 20.6629 8.37508 20.6629 8.75015C20.6629 9.12522 20.5139 9.48493 20.2487 9.75015L13.9987 16.0002L11.332 16.6668L11.9987 14.0002L18.2487 7.75015Z"
        stroke="#536787"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CreateChatHoverIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hidden group-hover/icons:block"
    >
      <mask id="path-1-inside-1_5003_29925" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#7A3DAA"
        fillOpacity="0.46"
        mask="url(#path-1-inside-1_5003_29925)"
      />
      <path
        d="M14 8H9.33333C8.97971 8 8.64057 8.14048 8.39052 8.39052C8.14048 8.64057 8 8.97971 8 9.33333V18.6667C8 19.0203 8.14048 19.3594 8.39052 19.6095C8.64057 19.8595 8.97971 20 9.33333 20H18.6667C19.0203 20 19.3594 19.8595 19.6095 19.6095C19.8595 19.3594 20 19.0203 20 18.6667V14"
        stroke="#7A3DAA"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2487 7.75015C18.5139 7.48493 18.8736 7.33594 19.2487 7.33594C19.6238 7.33594 19.9835 7.48493 20.2487 7.75015C20.5139 8.01537 20.6629 8.37508 20.6629 8.75015C20.6629 9.12522 20.5139 9.48493 20.2487 9.75015L13.9987 16.0002L11.332 16.6668L11.9987 14.0002L18.2487 7.75015Z"
        stroke="#7A3DAA"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SubmitChatQuestionIcon() {
  return (
    <svg
      width="28"
      height="30"
      viewBox="0 0 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="14" cy="15" rx="14" ry="14.5" fill="#D2D9E5" />
      <path
        d="M14.5892 8.24672C14.5119 8.16924 14.4199 8.10777 14.3188 8.06584C14.2176 8.0239 14.1092 8.00232 13.9997 8.00232C13.8902 8.00232 13.7817 8.0239 13.6806 8.06584C13.5794 8.10777 13.4875 8.16924 13.4101 8.24672L9.24356 12.4133C9.16613 12.4907 9.10472 12.5826 9.06282 12.6838C9.02092 12.7849 8.99935 12.8933 8.99935 13.0028C8.99935 13.1123 9.02092 13.2207 9.06282 13.3219C9.10472 13.4231 9.16613 13.515 9.24356 13.5924C9.32098 13.6698 9.4129 13.7312 9.51405 13.7731C9.61521 13.815 9.72363 13.8366 9.83313 13.8366C9.94262 13.8366 10.051 13.815 10.1522 13.7731C10.2534 13.7312 10.3453 13.6698 10.4227 13.5924L13.1664 10.8477L13.1664 20.5026C13.1664 20.7236 13.2542 20.9356 13.4104 21.0919C13.5667 21.2481 13.7787 21.3359 13.9997 21.3359C14.2207 21.3359 14.4326 21.2481 14.5889 21.0919C14.7452 20.9356 14.833 20.7236 14.833 20.5026L14.833 10.8477L17.5767 13.5924C17.733 13.7488 17.9451 13.8366 18.1662 13.8366C18.3874 13.8366 18.5994 13.7488 18.7558 13.5924C18.9122 13.436 19 13.224 19 13.0028C19 12.7817 18.9122 12.5696 18.7558 12.4133L14.5892 8.24672Z"
        fill="#536787"
      />
    </svg>
  );
}

export function ChatHistoryHideIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block group-hover/icons:hidden"
    >
      <mask id="path-1-inside-1_5003_29938" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_5003_29938)"
      />
      <path d="M14 9L9 14L14 19" stroke="#536787" strokeWidth="1.5" />
      <path d="M19 9L14 14L19 19" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryHideHoverIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hidden group-hover/icons:block"
    >
      <mask id="path-1-inside-1_5003_29942" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#7A3DAA"
        fillOpacity="0.46"
        mask="url(#path-1-inside-1_5003_29942)"
      />
      <path d="M14 9L9 14L14 19" stroke="#7A3DAA" strokeWidth="1.5" />
      <path d="M19 9L14 14L19 19" stroke="#7A3DAA" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryShowIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="block group-hover/icons:hidden"
    >
      <mask id="path-1-inside-1_5003_29727" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#D2D9E5"
        mask="url(#path-1-inside-1_5003_29727)"
      />
      <path d="M9 19L14 14L9 9" stroke="#536787" strokeWidth="1.5" />
      <path d="M14 19L19 14L14 9" stroke="#536787" strokeWidth="1.5" />
    </svg>
  );
}

export function ChatHistoryShowHoverIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="hidden group-hover/icons:block"
    >
      <mask id="path-1-inside-1_5003_29727" fill="white">
        <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" />
      </mask>
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z"
        fill="white"
      />
      <path
        d="M0 0H28H0ZM28 20C28 24.9706 23.9706 29 19 29H9C4.02944 29 0 24.9706 0 20C0 23.866 3.58172 27 8 27H20C24.4183 27 28 23.866 28 20ZM0 28V0V28ZM28 0V28V0Z"
        fill="#7A3DAA"
        fillOpacity="0.46"
        mask="url(#path-1-inside-1_5003_29727)"
      />
      <path d="M9 19L14 14L9 9" stroke="#7A3DAA" strokeWidth="1.5" />
      <path d="M14 19L19 14L14 9" stroke="#7A3DAA" strokeWidth="1.5" />
    </svg>
  );
}
